<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">商品管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodsList' }">
          <div class="div1">商品列表</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">{{ breadcrumbTitle }}</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content page-title">
      <h2>商品信息</h2>
    </div>
    <div class="content">
      <h3>基础信息</h3>
      <el-form :model="infoForm" :rules="infoRules" ref="infoForm" label-width="100px" class="info-form">
        <el-form-item label="商品分类">
          <div class="goods-category-edit">
            <span>{{ categoryArrStr }}</span>
            <span class="edit-btn" @click="toEditCategory">编辑</span>
          </div>
        </el-form-item>
        <el-form-item label="商品类型" prop="goodsTypes">
          <el-checkbox-group v-model="infoForm.goodsTypes" @change="selectT">
            <el-checkbox v-for="(item, index) in dictionaries.goods_type" :key="index" :label="item.dictId">{{
              item.dictName
            }}</el-checkbox>
          </el-checkbox-group>
          <!-- <el-radio-group
            v-model="infoForm.goodsType"
            :disabled="currentPageStatus !== 'add'"
            @change="selectT"
          >
            <el-radio
              v-for="item in dictionaries.goods_type"
              :key="item.dictId"
              :value="item.dictId"
              :label="item.dictName"
              :name="item.dictId"
            ></el-radio>
          </el-radio-group> -->
      </el-form-item>
      <el-form-item label="商品名称" prop="name" style="width: 830px;">
        <el-input v-model="infoForm.name" placeholder="请输入商品名称" maxlength="30" show-word-limit clearable></el-input>
      </el-form-item>
      <div  style="display: flex;height: 61px">
        <el-form-item label="外部商品" prop="isOut">
          <el-radio-group v-model="infoForm.isOut" style="width: 215px;">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品外部编号" style="width: 500px;">
          <el-input v-model="infoForm.outGoodsNo" placeholder="请输入商品外部编号" maxlength="24" show-word-limit
            clearable></el-input>
        </el-form-item>
      </div>

        <el-form-item label="标签" prop="tagList">
          <div class="labelbox" style="flex-wrap: wrap">
            <div class="labelitem" style="margin-bottom: 10px" v-for="(item, index) in seletedTag" :key="'dd' + item.id">
              {{ item.tagName }}
              <i v-if="currentPageStatus !== 'details'" class="el-icon-circle-close labelicon"
                @click="deleteTag(index)"></i>
            </div>
            <div class="primary-button" v-if="currentPageStatus !== 'details'" @click="addTag()">
              添加标签
            </div>
            <!-- <el-button type="primary" style="margin-bottom: 10px;" @click="showTagDialog = true"
              >添加标签</el-button> -->
          </div>
        </el-form-item>
        <!-- <el-form-item label="商品编码" v-if="infoForm.goodsNo" class="goods-no">
          <el-input v-model="infoForm.goodsNo" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="品牌" prop="brandId" class="brand-id">
          <el-select v-model="infoForm.brandId" placeholder="请选择所属品牌" filterable clearable>
            <el-option v-for="(item,index) in brandList" :key="index + item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="content attr">
      <div class="attr-title">类目属性</div>
      <div class="attr-content">
        <h4>商品属性</h4>
        <template v-for="(item, index) in goodsAttrData">
          <h5>{{ item.name }}</h5>
          <div class="attr-list">
            <form-filed :formconfig="item.formconfig" :formData="item.formData" @formDataval="dialogClick"
              :ref="'formAttr' + item.id" />
          </div>
        </template>
      </div>
    </div>
    <div class="content image-text-form">
      <h3><span style="color: #f33f3f">*</span>运费设置</h3>
      <el-form label-width="100px">
        <el-form-item label="运费设置">
          <el-select style="width: 40%" v-model="infoForm.shippingTemplateId" @change="selectModel">
            <el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <!-- <el-button type="text" style="margin-left: 10px">新增运费</el-button> -->
        </el-form-item>
        <el-form-item label="" v-if="isShowTemplate">
          <number v-if="detail.calculType == 1" :isEdit="false" :tableData="tableData" :freight="detail.freight"
            :baseNumber="detail.baseNumber" :addNum="detail.addNum" :addPrice="detail.addPrice" :key="Math.random()">
          </number>
          <weight v-if="detail.calculType == 2" :tableData="tableData" :freight="detail.freight"
            :baseNumber="detail.baseNumber" :addNum="detail.addNum" :addPrice="detail.addPrice" :isEdit="false"
            :key="Math.random()"></weight>
          <free-delivery v-if="tableDataF.length != 0" :tableData="tableDataF" style="margin-top: 10px"
            :isEdit="false"></free-delivery>
        </el-form-item>
      </el-form>
    </div>
    <div class="content image-text-form">
      <h3>图文信息</h3>
      <el-form label-width="100px">
        <el-form-item label="商品图片(0/10)">
          <label slot="label"><span style="color: red">*</span>商品图片({{
            fileList.length
          }}/10)</label>
          <div style="
              height: 17px;
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 400;
              line-height: 17px;
              color: #999999;
              opacity: 1;
              margin-bottom: 8px;
              margin-top: 10px;
            ">
            图片尺寸：建议上传750px*750px，每张上传大小不得超过8M,支持jpg、png格式
          </div>
          <upload-picture :limit="10" :list="fileList" @changeImage="changeImage" />
          <!--          <upload-picture></upload-picture>-->
        </el-form-item>
        <el-form-item label=""> </el-form-item>
        <el-form-item label="商品详情">
          <label slot="label"><span style="color: red">*</span>商品详情</label>
          <div style="
              height: 17px;
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 400;
              line-height: 17px;
              color: #999999;
              opacity: 1;
              margin-bottom: 8px;
              margin-top: 12px;
            ">
            若批量上传，建议一次不过20张，且每张大小不超过8M，支持jpg，png格式
          </div>
          <!--          <editor :init="editorInit" v-model="infoForm.detail" api-key="70xmc76i21jyu8ob8fmf4dtcjfpz0atkne1ttkxppmzsu230"/>-->
          <!-- <tinymce v-model="infoForm.details"></tinymce> -->
          <quill-editor v-model="infoForm.details" ref="myQuillEditor" :options="editorOption"
            class="editor"></quill-editor>
          <div class="bottom" style="display: none">
            <el-upload class="centerImg" :action="' '" list-type="picture-card" :auto-upload="true" multiple
              :before-upload="beforeUpload" :http-request="uploadFile" :on-change="handleChange" ref="uploadicon">
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="content" id="sku-content">
      <h3>价格库存</h3>
      <div class="sku-box">
        <div class="sku-title"><i>*</i><span>商品规格</span></div>
        <div class="sku-content-box">
          <div class="goods-sale">
            <el-select v-model="goodsSaleDataListValue" v-if="currentPageStatus === 'add'" placeholder="请选择" multiple
              collapse-tags :multiple-limit="3" :disabled="currentPageStatus !== 'add'"
              @change="onChangeGoodsSaleDataListValue">
              <el-option v-for="item in skuFormConfig.sourceAttribute" :key="item.name" :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <template v-if="skuFormConfig.attribute.length < 3">
              <el-button type="primary" :disabled="skuFormConfig.attribute.length > 2" @click="showInput()"
                v-if="!inputVisible && currentPageStatus === 'add'">添加规格</el-button>
              <el-button type="primary" :disabled="skuFormConfig.attribute.length > 2" @click="addSpecName()"
                v-if="inputVisible">确认添加</el-button>
            </template>
            <!-- <el-button type="primary">添加规格</el-button> -->
            <!-- <pre>{{skuFormConfig}}</pre> -->
            <div class="choose-attribute">
              <template v-for="(k, fatherIndex) in skuFormConfig.attribute">
                <!--                <h5>{{ k.name }}<span>（已选 {{ k.item.length }}）</span></h5>-->
                <h5>
                  <el-input size="small" v-model="k.name" @input="changeInput()"
                    @blur="changeAttributeTitle(k.name, fatherIndex)"
                    @focus="changeAttributeTitleFocus(k.name, fatherIndex)" placeholder="+ 自定义规格名称"></el-input>
                  <i class="el-icon-circle-close" @click="
                    onDeleteContent(fatherIndex, childrenIndex, 'father')
                    " v-if="currentPageStatus === 'add'"></i>
                  <hr />
                  <span>规格值</span>
                  <span>（已选 {{ k.item.length }}）</span>
                </h5>
                <div class="choose-attribute-list">
                  <!--
                  <el-tag
                      :key="tag"
                      v-for="tag in k.item"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(tag)">
                    {{tag}}
                  </el-tag>
                  -->
                  <template v-for="(tag, childrenIndex) in k.item">
                    <template v-if="skuFormConfig.attribute[fatherIndex].itemList[
                      childrenIndex
                    ]
                      ">
                      <el-input size="small" :key="childrenIndex" v-model="skuFormConfig.attribute[fatherIndex].itemList[
                        childrenIndex
                      ].content
                        " v-if="skuFormConfig.attribute[fatherIndex].itemList[
    childrenIndex
  ].content
    " @input="changeInput()" @change="onChangeContent(fatherIndex, childrenIndex)">
                      </el-input><i class="el-icon-circle-close" @click="onDeleteContent(fatherIndex, childrenIndex)"
                        v-if="currentPageStatus === 'add'"></i>
                    </template>
                  </template>
                  <el-input class="input-new-tag" v-model="skuFormConfig.inputValueArrTemp[fatherIndex]"
                    ref="saveTagInput" size="small" placeholder="+ 自定义规格值"
                    @keyup.enter.native="handleInputConfirm(fatherIndex)" @blur="handleInputConfirm(fatherIndex)"
                    @focus="onFocus(fatherIndex)" @input="changeInput()">
                    <el-button slot="append" icon="el-icon-check" type="primary"
                      @click="handleInputConfirm(fatherIndex, '1')"></el-button>
                  </el-input>
                  <!--                  <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 自定义规格值</el-button>-->
                </div>
              </template>
              <template v-if="skuFormConfig.attribute.length < 3">
                <h5 v-if="inputVisible">
                  <el-input size="small" v-model="specNameTemp.name" @input="changeInput()"
                    placeholder="+ 自定义规格名称"></el-input>
                </h5>
                <div class="choose-attribute-list" v-if="inputVisible">
                  <el-input size="small" placeholder="+ 自定义规格值" v-model="specNameTemp.item" @input="changeInput()">
                  </el-input>
                </div>
              </template>
            </div>
          </div>
          <div>
            <batchInput @dealData="batchSetPrice"/>
          </div>
          <div class="goods-sale-list">
            <SkuForm ref="skuForm" :source-attribute="skuFormConfig.sourceAttribute"
              :attribute.sync="skuFormConfig.attribute" :sku.sync="skuFormConfig.sku" :disabled="skuFormConfig.showForm"
              :structure="skuFormConfig.structure" v-if="skuFormConfig.attribute.length !== 0">
              <template #skuNo="slotSkuNo">
                {{ slotSkuNo.row.skuNo ? slotSkuNo.row.skuNo : "- -" }}
              </template>
              <template #image="slotImg">
                <mall-picture :imageUrl="slotImg.row.image" @getUrl="getImage($event, slotImg)"></mall-picture>
              </template>
              <template #settlementPrice="slotProps">
                <span style="color: red" v-if="slotProps.row.retailPrice">建议结算价<span>：{{
                  Number(
                    Number(slotProps.row.retailPrice) -
                    (Number(slotProps.row.retailPrice) *
                      maxNormalProportion) /
                    100
                  ).toFixed(2)
                }}-{{
  Number(
    Number(slotProps.row.retailPrice) -
    (Number(slotProps.row.retailPrice) *
      minNormalProportion) /
    100
  ).toFixed(2)
}}</span></span>
                <el-input placeholder="请输入结算价" v-model="slotProps.row.settlementPrice" size="small"
                  @change="selectSettlement($event, slotProps.$index)">
                </el-input>
              </template>
              <template #status="slotProps">
                <el-switch v-model="slotProps.row.status" active-value="1" inactive-value="0"
                  @change="onChangeSkuStatus($event, slotProps.row)"></el-switch>
              </template>
              <template #bindingSkuNo="slotBindingSkuNo">
                <!-- <span v-if="slotHandSkuNo.row.handSkuNo">{{ slotHandSkuNo }}</span> -->
                <el-button type="text" @click="showDialogSkuVisible($event, slotBindingSkuNo)">手动绑定SKU</el-button>
              </template>
              <template #relationSku="slotBindingGoods">
                <el-button type="text" @click="
                  showDialogGoodsVisible($event, slotBindingGoods.$index)
                  ">绑定关联商品</el-button>
              </template>
            </SkuForm>
            <div style="margin-top: 20px" v-if="goodsL && goodsL.length != 0">
              <div style="color: #333333; font-size: 14px">关联商品</div>
              <el-table border :data="goodsL" :span-method="objectSpanMethod" style="width: 50%; margin-top: 20px"
                :header-cell-style="{
                  'text-align': 'center',
                  background: '#F8F8F8',
                  color: '#333333',
                }" :cell-style="{ 'text-align': 'center' }">
                <el-table-column prop="skuName" label="原商品规格" width="150">
                </el-table-column>
                <el-table-column prop="name" label="绑定的商品名称">
                </el-table-column>
                <el-table-column prop="bindGoodsSku" label="绑定SKU">
                </el-table-column>
                <el-table-column prop="status" label="商品规格状态">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status == 1">已上架</div>
                    <div v-if="scope.row.status == 0">已下架</div>
                  </template>
                </el-table-column>
                <el-table-column prop="goodsQuantity" label="绑定数量">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!--          <sku ref="sku" @change="changeSku" :th-list="thList" class="sku-table"></sku>-->
        </div>
      </div>

      <!-- <div v-if="infoForm.minPrice && infoForm.maxPrice" class="market-price">
        <h3 class="max-min-price">
          <span>市场价</span
          ><span>¥ {{ infoForm.minPrice }} - {{ infoForm.maxPrice }}</span
          >元
        </h3>
      </div> -->
      <!-- <pre>{{skuFormConfig.attribute}}</pre> -->
      <div>
        <el-form label-width="100px">
          <el-form-item label="上架平台" prop="platformIds">
            <label slot="label">
              <!-- <span style="color: red">*</span> -->
              上架平台</label>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
              @change="handleCheckAllChange">全选(未选平台，默认五域上架)</el-checkbox>
            <el-checkbox-group v-model="infoForm.platformIds" @change="handleCheckedplatformChange">
              <el-checkbox v-for="item in platforms" :label="item.platformId" :key="item.platformId">{{ item.platformName
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="平台是否审核上架">
            <div slot="label" style="line-height: 20px">
              <span style="color: red">*</span>平台是否审核上架
            </div>
            <el-radio-group v-model="infoForm.isVerifyShelves" @change="selectIsUp">
              <el-radio v-for="item in dictionaries.is_verify_shelves" :key="item.dictId" :value="item.dictId"
                :label="item.dictId" :name="item.dictName">{{ item.dictName }}
                <el-tooltip v-if="item.dictId == 1" class="item" effect="dark" content="平台手动审核商品是否上架"
                  placement="top-start">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <el-tooltip v-if="item.dictId == 2" class="item" effect="dark" content="五域设定该商品直接在所选平台中售卖"
                  placement="top-start">
                  <i class="el-icon-question"></i> </el-tooltip></el-radio>
            </el-radio-group>
            <!-- <div>
              <el-radio>平台审核</el-radio>
              <el-radio>直接上架</el-radio>
            </div> -->
          </el-form-item>
          <div v-if="infoForm.isVerifyShelves == 2 && showPlatform.length != 0" style="
              margin-left: 220px;
              margin-top: -20px;
              width: 710px;
              height: auto;
              background: #f1f6ff;
              opacity: 1;
              border-radius: 0px;
              padding-left: 12px;
              padding-top: 12px;
              padding-bottom: 12px;
            ">
            <div style="
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #333333;
              ">
              该商品直接上架平台<span v-if="showPlatform.length != 0">【</span>
              <span v-for="(item, index) in showPlatform" :key="index" style="color: red"><span v-if="index > 0"
                  style="color: red">，</span>{{ item.name }}</span>
              <span v-if="showPlatform.length != 0">】</span>平台的【收益】出现亏损！请重新选择上架平台
            </div>
            <div @click="qx" style="
                width: 72px;
                height: 24px;
                background: #ffffff;
                border: 1px solid #4168e7;
                opacity: 1;
                border-radius: 3px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 24px;
                color: #4168e7;
                text-align: center;
                margin-top: 10px;
              ">
              一键取消
            </div>
          </div>
          <el-form-item label="是否上架后续新增平台">
            <div slot="label" style="line-height: 20px">
              <span style="color: red">*</span>是否上架后续新增平台
            </div>
            <el-radio-group v-model="infoForm.isShelvesAddedPlatform">
              <el-radio v-for="item in dictionaries.is_shelves_added_platform" :key="item.dictId" :value="item.dictId"
                :label="item.dictId" :name="item.dictId">
                {{ item.dictName }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content bottom-but">
      <el-button type="warning" @click="back()">返回</el-button>
      <el-button type="primary" @click="verificationData"
        :disabled="showPlatform.length != 0 && infoForm.isVerifyShelves == 2"
        v-if="parArray.indexOf('eidt_chengbenjia') != -1">{{ submitButtonText }}</el-button>
    </div>

    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :append-to-body="true"
      :custom-class="dialog.type === 'modifyState' ? 'modify-state' : ''">
      <template v-if="dialog.type === 'modifyState'">
        <modify-state :dialogInfo="dialog" :list="giftListByGoodId"></modify-state>
        <div slot="title" class="header-title">
          <span class="icon"><i class="el-icon-warning"></i></span>
          <label class="name">{{ dialog.title }}</label>
        </div>
        <div slot="footer" class="footer">
          <el-button @click="centerModifyState">取 消</el-button>
          <el-button type="primary" @click="submitModifyState">确 定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="添加标签" :visible.sync="dialogVisible" append-to-body width="50%">
      <div class="loglabelbox">
        <div class="loglabeltopbox">
          <div class="labelitem" :style="{ cursor: item.select ? 'not-allowed' : 'pointer' }"
            :class="[item.select ? 'selected' : 'notselected']" v-for="(item, index) in tagList" :key="'dd' + item.id"
            @click="selectTagFn(index)">
            {{ item.tagName }}
          </div>
        </div>
        <div class="circlebox">
          已选
          <div class="circle">
            {{ seletedTag.length }}
          </div>
        </div>
        <div class="loglabeltopbox" style="border: none">
          <div class="labelitem labelitemc" v-for="(item, index) in seletedTag" :key="'dd' + item.id">
            {{ item.tagName }}
            <i class="el-icon-circle-close labelicon" @click="deleteTag(index)"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="绑定SKU" :visible.sync="dialogSkuVisible" append-to-body width="32%">
      <div style="margin-left: 30px">
        SKU编码
        <el-input v-model="bindingSkuNo" placeholder="请输入所需绑定的SKU" style="width: 400px; margin-left: 15px"></el-input>
      </div>
      <span style="margin-left: 106px; color: #f33f3f; font-size: 12px">请留意新旧商品规格是否一致</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSkuVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindSku">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="关联商品" :visible.sync="isGoods" append-to-body width="40%" :close-on-click-modal="false">
      <div style="display: flex; justify-content: start" v-for="(item, index) in skus" :key="index">
        <div style="display: flex; margin-bottom: 20px">
          <div style="line-height: 30px; margin-right: 20px">绑定SKU</div>
          <div>
            <el-input v-model="item.bindGoodsSku" placeholder="请输入绑定的SKU" size="small" style="width: 232px"
              @change="selectSku($event, index)" oninput="value=value.replace(/|[^0-9]/g, '')"></el-input>
          </div>
        </div>
        <div style="display: flex">
          <div style="line-height: 30px; margin-right: 20px; margin-left: 20px">
            绑定数量
          </div>
          <div>
            <el-input v-model="item.goodsQuantity" placeholder="请输入绑定的数量" style="width: 232px"
              oninput="value=value.replace(/|[^0-9]/g, '')" size="small"></el-input>
          </div>
        </div>
        <div @click="deleteSku(index)" style="color: red; line-height: 30px; margin-left: 20px;cursor: pointer;">
          删除
        </div>
      </div>
      <div>
        <el-button type="text" @click="addGoodsSku">增加绑定</el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isGoods = false">取 消</el-button>
        <el-button type="primary" @click="bindSkuGoods">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择标签" :visible.sync="showTagDialog" width="1010px" append-to-body>
      <div class="tag—table-box">
        <el-form ref="tagForm" :model="tagForm" :inline="true" id="search" size="small">
          <el-form-item label="标签" prop="name">
            <el-input v-model="tagForm.name" clearable placeholder="标签名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="分类" prop="typeFlag">
            <el-select v-model="tagForm.typeFlag" placeholder="请选择分类" clearable>
              <el-option v-for="item in dictionaries.goods_tag_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="类目" prop="tagClass">
            <el-select v-model="tagForm.tagClass" placeholder="请选择类目" clearable>
              <el-option v-for="item in dictionaries.goods_tag_class" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="primary-mini" @click="fetchData()">查询</div>
            <div class="primary-mini" @click="fetchData('reset')">重置</div>
            <!-- <el-button type="primary" @click="fetchData()">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button> -->
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 20px">
          <div class="primary-plain" @click="batchSelectTag(1)">批量选择</div>
          <div class="primary-plain" @click="batchSelectTag(2)">批量取消</div>
          <!-- <el-button type="primary" size="mini" plain @click="batchSelectTag(1)">批量选择</el-button>
          <el-button type="primary" size="mini" plain @click="batchSelectTag(2)">批量取消</el-button> -->
        </div>
        <el-table :data="tagList" style="width: 100%" :header-cell-style="{ background: '#F8F8F8', color: '#333333', }"
          @selection-change="handleSelectionChange" :cell-style="{ padding: '0' }">
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="标签" prop="tagName"></el-table-column>
          <el-table-column label="排序" prop="sort"></el-table-column>
          <el-table-column label="标签分类" prop="typeName"></el-table-column>
          <el-table-column label="标签类目" prop="className"></el-table-column>
          <el-table-column label="是否对外展示" prop="" align="center">
            <template slot-scope="scope">
              <p style="text-align: center">
                {{ scope.row.showFlag == 1 ? "是" : "否" }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="tagName" align="center">
            <template slot-scope="scope">
              <div class="tag-status">
                <div class="circle1" :style="{
                  'background-color':
                    scope.row.status == 1 ? '#67c23a' : 'red',
                }"></div>
                <span>{{ scope.row.status == 1 ? "启用" : "停用" }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="">
            <template slot-scope="scope">
              <el-button type="text" v-if="!scope.row.selected" @click="handleSelectTag(scope)">选择</el-button>
              <el-button type="text" style="color: red" v-if="scope.row.selected"
                @click="handleSelectTag(scope)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="
            margin-bottom: 20px;
            background-color: #f8f8f8;
            overflow: hidden;
          ">
          <div style="float: right">
            <el-pagination v-if="tagList.length > 0" background @size-change="onSizeChange"
              @current-change="onCurrentChange" :current-page="labelPageNo" :page-sizes="[10, 20, 50]"
              :page-size="labelPageSize" layout="total, sizes, prev, pager, next, jumper" :total="labelTotalNum">
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="primary-gray" @click="showTagDialog = false">关 闭</div>
        <!-- <div class="primary-button" @click="showTagDialog = false">确 定</div> -->
        <!-- <el-button @click="showTagDialog = false">取 消</el-button>
        <el-button type="primary" @click="showTagDialog = false">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="dialogCategory" append-to-body width="32%">
      <categoryDialog :categoryIds="cIds" @changeC="changeC"></categoryDialog>
    </el-dialog>
  </div>
</template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册
// import Tinymce from '@/components/Tinymce/index'
import uploadPicture from '@/components/upload/dragpicture.vue'
// import sku from "./components/sku/index"
import formFiled from '@/components/form/index'
import SkuForm from 'vue-sku-form'
import mixinsGoodsEdit from './mixins/mixinsGoodsEdit.js'
import mixinsGoodsEditQuill from './mixins/mixinsGoodsEditQuill1.js'

import mixinsGiftlist from './mixins/mixinsGiftlist.js'

import ModifyState from './components/ModifyState.vue'

import common from '../matrix/mixins/common'
import number from './components/number.vue'
import weight from './components/weight.vue'
import FreeDelivery from './components/freeDelivery.vue'
import mallPicture from '@/components/upload/mallPicture.vue'
import categoryDialog from './components/categoryDialog.vue'
import batchInput from '@/components/batchInput.vue'

const checkNumber = (data, index, callback) => {
  const val = data[index].stock
  // console.log(typeof val === 'number', !isNaN(val))
  console.log(typeof val === 'number' && !isNaN(val))
  if (!isNaN(val)) {
    callback()
  }
  callback(new Error('填写有误'))
}
export default {
  components: {
    uploadPicture,
    formFiled,
    SkuForm,
    quillEditor,
    ModifyState,
    number,
    weight,
    FreeDelivery,
    mallPicture,
    categoryDialog,
    batchInput,
  },
  data() {
    return {
      dialogCategory: false,
      copySkuStructure: [],
      showPlatform: [],
      time: 0,
      models: [

      ],
      radio: 3,
      min: 0,
      max: 0,
      fileList: [],
      currentPageStatus: 'add', // 当前页面状态 add 添加 ， edit 编辑
      breadcrumbTitle: '新增商品',
      maxSkuNo: 1, // 通过接口获取最大 skuNo
      formFiledDataState: true, // 类目属性 状态
      skuFormConfig: {
        sourceAttribute: [], // SKU可选属性
        attribute: [], // SKU已选属性，支持 .sync 修饰符
        structure: [ // 表单结构
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   console.log(data)
            //   // const val = data[index].marketPrice
            //   // if (!isNaN(val) && val > -1) {
            //   //   data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //   //   callback()
            //   // }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'marketPrice', type: 'input', label: '市场价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              console.log(data)
              const val = data[index].marketPrice
              if (!isNaN(val) && val > -1) {
                data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'retailPrice', type: 'input', label: '零售价(元)', batch: false, required: true,
            tip: '设置的零售价为各平台的售卖价格（价格设置需大于结算价）',
            validate: (data, index, callback) => {
              const val = data[index].retailPrice
              if (!isNaN(val) && val > -1) {
                data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                if (Number(data[index].retailPrice) >= Number(data[index].settlementPrice)) {
                  // data[index].min = Number(data[index].retailPrice) - Number(data[index].retailPrice) * this.minNormalProportion / 100
                  // data[index].max = Number(data[index].retailPrice) - Number(data[index].retailPrice) * this.maxNormalProportion / 100
                  callback()
                } else {
                  callback(new Error('结算价不能大于零售价'))
                }

                //
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'costPrice', type: 'input', label: '成本价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].costPrice = Number(data[index].costPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'purchasePrice', type: 'input', label: '内购价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].purchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].purchasePrice = Number(data[index].purchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'settlementPrice', type: 'slot', label: '结算价(元)', batch: false, required: true,
            tip: '结算价为与平台结算佣金的价格（结算价设置要小于零售价）',
            validate: (data, index, callback) => {
              const val = data[index].settlementPrice
              console.log(val)
              if (!isNaN(val) && val > -1) {
                // data[index].settlementPrice = Number(data[index].settlementPrice).toFixed(2)
                if (Number(data[index].retailPrice) >= Number(data[index].settlementPrice)) {
                  callback()
                } else {
                  callback(new Error('结算价不能大于零售价'))
                }
                // callback()
              }
              callback(new Error('填写有误'))
              this.$forceUpdate()
            }
          },
          {
            name: 'convertPrice', type: 'input', label: '折算价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].convertPrice = Number(data[index].convertPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'bulkPurchasePrice', type: 'input', label: '集采价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].bulkPurchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].bulkPurchasePrice = Number(data[index].bulkPurchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'agentPrice', type: 'input', label: '代理价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].agentPrice
              if (!isNaN(val) && val > -1) {
                data[index].agentPrice = Number(data[index].agentPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'input', label: '库存', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'initSellNum', type: 'input', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'weight', type: 'input', label: '重量(千克)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].weight
              if (!isNaN(val) && val > -1) {
                data[index].weight = Number(data[index].weight).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
          {
            name: 'status',
            type: 'slot',
            defaultValue: '1',
            label: '上下架',
            tip: '单个 SKU 上架和下架状态！'
          },
          { name: 'bindingSkuNo', type: 'slot', label: '手动绑定SKU', batch: false, tip: '适用于【九航】系统(普通商品和身份商品)' },
          { name: 'relationSku', type: 'slot', label: '关联商品', batch: false, tip: '该规格绑定多个商品，实际按绑定规格发货' },
        ],
        structure1: [ // 表单结构
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   console.log(data)
            //   // const val = data[index].marketPrice
            //   // if (!isNaN(val) && val > -1) {
            //   //   data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //   //   callback()
            //   // }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'marketPrice', type: 'input', label: '市场价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              console.log(data)
              const val = data[index].marketPrice
              if (!isNaN(val) && val > -1) {
                data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'costPrice', type: 'input', label: '成本价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].costPrice = Number(data[index].costPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'retailPrice', type: 'input', label: '零售价(元)', batch: false, required: true,
            tip: '设置的零售价为各平台的售卖价格（价格设置需大于结算价）',
            validate: (data, index, callback) => {
              const val = data[index].retailPrice
              if (!isNaN(val) && val > -1) {
                data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                if (Number(data[index].retailPrice) >= Number(data[index].settlementPrice)) {
                  // data[index].min = Number(data[index].retailPrice) - Number(data[index].retailPrice) * this.minNormalProportion / 100
                  // data[index].max = Number(data[index].retailPrice) - Number(data[index].retailPrice) * this.maxNormalProportion / 100
                  callback()
                } else {
                  callback(new Error('结算价不能大于零售价'))
                }

                //
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'purchasePrice', type: 'input', label: '内购价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].purchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].purchasePrice = Number(data[index].purchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'settlementPrice', type: 'slot', label: '结算价(元)', batch: false, required: true,
            tip: '结算价为与平台结算佣金的价格（结算价设置要小于零售价）',
            validate: (data, index, callback) => {
              const val = data[index].settlementPrice
              console.log(val)
              if (!isNaN(val) && val > -1) {
                // data[index].settlementPrice = Number(data[index].settlementPrice).toFixed(2)
                if (Number(data[index].retailPrice) >= Number(data[index].settlementPrice)) {
                  callback()
                } else {
                  callback(new Error('结算价不能大于零售价'))
                }
                // callback()
              }
              callback(new Error('填写有误'))
              this.$forceUpdate()
            }
          },
          {
            name: 'convertPrice', type: 'input', label: '折算价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].convertPrice = Number(data[index].convertPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'bulkPurchasePrice', type: 'input', label: '集采价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].bulkPurchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].bulkPurchasePrice = Number(data[index].bulkPurchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'agentPrice', type: 'input', label: '代理价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].agentPrice
              if (!isNaN(val) && val > -1) {
                data[index].agentPrice = Number(data[index].agentPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'input', label: '库存', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'initSellNum', type: 'input', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'weight', type: 'input', label: '重量(千克)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].weight
              if (!isNaN(val) && val > -1) {
                data[index].weight = Number(data[index].weight).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
          {
            name: 'status',
            type: 'slot',
            defaultValue: '1',
            label: '上下架',
            tip: '单个 SKU 上架和下架状态！'
          },
          { name: 'bindingSkuNo', type: 'slot', label: '手动绑定SKU', batch: false, tip: '适用于【九航】系统(普通商品和身份商品)' },
          { name: 'relationSku', type: 'slot', label: '关联商品', batch: false, tip: '该规格绑定多个商品，实际按绑定规格发货' },
        ],
        structure2: [ // 表单结构
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   console.log(data)
            //   // const val = data[index].marketPrice
            //   // if (!isNaN(val) && val > -1) {
            //   //   data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //   //   callback()
            //   // }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'marketPrice', type: 'input', label: '市场价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              console.log(data)
              const val = data[index].marketPrice
              if (!isNaN(val) && val > -1) {
                data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'costPrice', type: 'input', label: '成本价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].costPrice = Number(data[index].costPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'retailPrice', type: 'input', label: '零售价(元)', batch: false, required: true,
            tip: '设置的零售价为各平台的售卖价格（价格设置需大于结算价）',
            validate: (data, index, callback) => {
              const val = data[index].retailPrice
              if (!isNaN(val) && val > -1) {
                data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                if (Number(data[index].retailPrice) >= Number(data[index].settlementPrice)) {
                  // data[index].min = Number(data[index].retailPrice) - Number(data[index].retailPrice) * this.minNormalProportion / 100
                  // data[index].max = Number(data[index].retailPrice) - Number(data[index].retailPrice) * this.maxNormalProportion / 100
                  callback()
                } else {
                  callback(new Error('结算价不能大于零售价'))
                }

                //
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'purchasePrice', type: 'input', label: '内购价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].purchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].purchasePrice = Number(data[index].purchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'settlementPrice', type: 'slot', label: '结算价(元)', batch: false, required: true,
            tip: '结算价为与平台结算佣金的价格（结算价设置要小于零售价）',
            validate: (data, index, callback) => {
              const val = data[index].settlementPrice
              console.log(val)
              if (!isNaN(val) && val > -1) {
                // data[index].settlementPrice = Number(data[index].settlementPrice).toFixed(2)
                if (Number(data[index].retailPrice) >= Number(data[index].settlementPrice)) {
                  callback()
                } else {
                  callback(new Error('结算价不能大于零售价'))
                }
                // callback()
              }
              callback(new Error('填写有误'))
              this.$forceUpdate()
            }
          },
          {
            name: 'convertPrice', type: 'input', label: '折算价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].convertPrice = Number(data[index].convertPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'bulkPurchasePrice', type: 'input', label: '集采价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].bulkPurchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].bulkPurchasePrice = Number(data[index].bulkPurchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'agentPrice', type: 'input', label: '代理价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].agentPrice
              if (!isNaN(val) && val > -1) {
                data[index].agentPrice = Number(data[index].agentPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'input', label: '库存', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'initSellNum', type: 'input', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
          {
            name: 'status',
            type: 'slot',
            defaultValue: '1',
            label: '上下架',
            tip: '单个 SKU 上架和下架状态！'
          },
          { name: 'bindingSkuNo', type: 'slot', label: '手动绑定SKU', batch: false, tip: '适用于【九航】系统(普通商品和身份商品)' },
          { name: 'relationSku', type: 'slot', label: '关联商品', batch: false, tip: '该规格绑定多个商品，实际按绑定规格发货' },
        ],
        structure3: [ // 表单结构
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   console.log(data)
            //   // const val = data[index].marketPrice
            //   // if (!isNaN(val) && val > -1) {
            //   //   data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //   //   callback()
            //   // }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'marketPrice', type: 'input', label: '市场价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              console.log(data)
              const val = data[index].marketPrice
              if (!isNaN(val) && val > -1) {
                data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'costPrice', type: 'input', label: '成本价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].costPrice = Number(data[index].costPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'retailPrice', type: 'input', label: '零售价(元)', batch: false, required: true,
            tip: '设置的零售价为各平台的售卖价格（价格设置需大于结算价）',
            validate: (data, index, callback) => {
              const val = data[index].retailPrice
              if (!isNaN(val) && val > -1) {
                data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                callback()
                // if (Number(data[index].retailPrice) >= Number(data[index].settlementPrice)) {
                //   // data[index].min = Number(data[index].retailPrice) - Number(data[index].retailPrice) * this.minNormalProportion / 100
                //   // data[index].max = Number(data[index].retailPrice) - Number(data[index].retailPrice) * this.maxNormalProportion / 100
                //   callback()
                // } else {
                //   callback(new Error('结算价不能大于零售价'))
                // }

                //
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'input', label: '库存', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'initSellNum', type: 'input', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
          {
            name: 'status',
            type: 'slot',
            defaultValue: '1',
            label: '上下架',
            tip: '单个 SKU 上架和下架状态！'
          },
          { name: 'bindingSkuNo', type: 'slot', label: '手动绑定SKU', batch: false, tip: '适用于【九航】系统(普通商品和身份商品)' },
          { name: 'relationSku', type: 'slot', label: '关联商品', batch: false, tip: '该规格绑定多个商品，实际按绑定规格发货' },
        ],
        sku: [], // SKU数据，支持 .sync 修饰符
        theme: 2, // SKU选择栏主题风格，可选1或2
        showForm: true, // 是否显示SKU选择栏  false 显示 true 隐藏
        inputValueArr: [],
        inputValueArrTemp: []
      },
      submitButtonText: '发布商品', // 提交按钮方案
      isGoods: false,
      infoForm: { // 基础信息
        categoryId: '', //	是	int	类目id （数据来源：接口 - /order/comm/commodityCategory/commList）
        goodsTypes: [], //	是	string	商品类型（字典：goods_type）
        goodsType: '1',
        name: '', //	是	string	商品名称
        isOut: '', // 是否外部商品 1是，0不是
        brandId: '', //	是	int	品牌id（数据来源：接口 - /order/comm/brand/commList?pageNo=1&pageSize=999）
        attrList: '', //	是	Object[]	商品属性组列表
        // imageList: [{url: "http://fenxiao.muruji.com/internalSystem/76c19d4d-5a0e-4ff2-9b4f-239040be1d58"}], //	是	Object[]	图片列表
        imageList: [], //	是	Object[]	图片列表
        details: '', //	否	string	详情
        specList: [], //	是	Object[]	规格列表
        skuList: [], //	是	Object[]	sku列表
        status: '', //	是	string	状态（字典分组：enable_status）
        goodsNo: '', // 商品编号
        maxPrice: '', // 最高价
        minPrice: '', // 最低价
        submitButtonText: '发布商品', // 提交按钮方案
        tagList: [],//标签
        shippingTemplateId: '',//运费Id
        isVerifyShelves: '',//平台是否审核上架
        isShelvesAddedPlatform: '',//是否上架后续新增平台
        platformIds: [],
        freightModeId: null,
        freightTemplateId: null,
        outGoodsNo: ''
      },
      isShowTemplate: false,
      infoRules: { // 基础验证
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        isOut: [
          { required: true, message: '请选择是否外部商品', trigger: 'blur' }
        ],
        brandId: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        goodsTypes: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]
      },
      categoryIdArr: [], // 获取路由 categoryId
      categoryArrStr: '', // 回显 category
      goodsAttrDataList: [], // 类目商品属性库列表
      goodsSaleDataList: [], // 类目的销售属性列表
      goodsSaleDataListValue: [],
      goodsAttrData: [{ formconfig: {}, formData: {} }],
      formFiledData: {}, // 表单组件数 商品属性组列表
      currentStatus: 100, // 当前列表状态
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      selectionId: [], // 选 中 id
      parArray: [], // 按钮权限
      skuList: [],
      lastSkuStatus: [],
      changeGoodsStatusNum: 0,
      tagList: [],//标签
      seletedTag: [],
      dialogVisible: false,
      dialogSkuVisible: false,
      tagForm: {
        name: '',
        tagType: '1',
        tagClass: ''
      },
      labelPageNo: 1,
      labelPageSize: 10,
      labelTotalNum: 0,
      showTagDialog: false,
      tagSelectionList: [],
      bindingSkuNo: '',
      skuIndex: 0,
      editTagList: [],
      detail: {},
      tableData: [],
      tableDataF: [],
      platforms: [],
      isIndeterminate: true,
      checkAll: false,
      maxNormalProportion: 0,
      minNormalProportion: 0,
      cIds: [],
      skus: [
        // {
        //   bindGoodsSku: '',
        //   goodsQuantity: null,
        //   name: '',
        //   status: ''
        // }
      ],
      goodsL: [],
      gIndex: 0,
      goods: []
    }
  },
  mixins: [mixinsGoodsEdit, mixinsGoodsEditQuill, mixinsGiftlist],
  // mounted () { this.addQuillTitle() },
  created() {
    this.initialization() // 初始化 信息
    this.getButtonTreeDto() // 获取权限设定
    this.getTagList() // 获取标签数据
    this.getList()//获取模板列表
    console.log(this.dictionaries)
    this.getDictionaries('is_verify_shelves')
    this.getDictionaries('is_shelves_added_platform')
    this.goodRate()
    // this.getPlatformList()
  },
  watch: {
    infoForm: {
      handler(newVal, oldVal) {
        // console.log('infoForm', newVal)
        const rQuery = this.$route.query
        const goodsId = rQuery.id
        // console.log('goodsId', [goodsId])
        // if (newVal && newVal.status && newVal.status.indexOf('下') > -1 && rQuery.type === 'edit' && this.changeGoodsStatusNum > 3) {
        //   // console.log(newVal.status, this.changeGoodsStatusNum)
        //   // this.checkGiftListByGoodId([goodsId])
        // }
        console.log(newVal.skuList)
        this.changeGoodsStatusNum++
      },
      deep: true
    },
    skuFormConfig: {
      handler(newVal, oldVal) {
        console.log(newVal)
        const rQuery = this.$route.query
        // console.log('skuList', this.infoForm.skuList)
        const arr = []
        let skuStatusNum = 0
        newVal.sku.forEach(item => {
          arr.push(item.marketPrice)
          if (item.status === '0') { skuStatusNum++ }
        })
        // if (newVal.sku.length === skuStatusNum) {
        //   this.infoForm.status = this.dictionaries.sale_status[0].dictName
        //   console.log(this.infoForm.status)
        //   // console.log('下')
        // }
        if (rQuery.type === 'edit') {
          // this.isActionCheckGift(newVal, oldVal)
        }
        // this.checkGiftListBySkuId(skuIds)
        const sortArr = arr.sort(function (a, b) { return a - b })
        // console.log(sortArr)
        // this.infoForm.maxPrice = sortArr[sortArr.length - 1] // 最高价
        // this.infoForm.minPrice = sortArr[0] // 最低价
        this.$forceUpdate()
      },
      deep: true // 为true，表示深度监听，这时候就能监测到a值变化
    },
    goodsSaleDataListValue(a, b) {
      console.log(a, b)
      if (this.skuFormConfig.attribute.length > 3) {
        this.$message({
          message: '规格最多只有三条',
          type: 'warning'
        })
        this.onChangeGoodsSaleDataListValue(b)
      }
    }
  },
  computed: {},
  methods: {
    //表格合并行和列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let pos = 0
      let len = this.goodsL.length
      for (let i = 0; i < len; i++) {
        const item = this.goodsL[i]
        if (i === 0) {
          item.$rows = 1
          pos = 0
        }
        if (i !== 0) {
          if (item.skuName === this.goodsL[i - 1].skuName) {
            item.$rows = 0
            this.goodsL[pos].$rows = this.goodsL[pos].$rows + 1
          } else {
            item.$rows = 1
            pos = i
          }
        }
      }
      if (columnIndex === 0) {
        return {
          rowspan: row.$rows,
          colspan: row.$rows ? 1 : 0,
        };
      }
    },
    selectSku(val, index) {
      console.log(val, this.skus)
      let skus = JSON.parse(JSON.stringify(this.skus))
      skus.splice(index, 1)
      let isC = skus.find(item => item.bindGoodsSku == val)
      console.log(isC)
      if (isC) {
        this.$message.error('绑定SKU重复')
        return
      }
      this.axios.post('/goods/goodsSkuBindSku/getSkuInfo', { sku: val }).then(res => {
        if (res.code == 0) {
          console.log(res.data)
          this.skus[index].name = res.data.name
          this.skus[index].status = res.data.status
          this.skuFormConfig.sku[this.gIndex].relationSku = this.skus
        } else {
          this.$message.error(res.message)
          this.skus[index].bindGoodsSku = ''
        }
      })
      // this.$api.getSkuInfoList({ sku: val }).then(res => {
      //   if (res.code == 0) {
      //     console.log(res.data)
      //     this.skus[index].name = res.data.name
      //     this.skus[index].status = res.data.status
      //     this.skuFormConfig.sku[this.gIndex].relationSku = this.skus
      //   }
      // })
    },
    //关联商品
    bindSkuGoods() {
      console.log(this.skuFormConfig)
      if (!this.skuFormConfig.sku[this.gIndex]) {
        this.$message.error('规格数据未填')
        return
      }
      let isS = this.skus.every(item => item.bindGoodsSku != '' && item.goodsQuantity != '')
      if (!isS) {
        this.$message.error('存在未填写的SKU或者数量')
        return
      }
      let skus = this.skus.map(item => item["bindGoodsSku"]);
      let S = new Set(skus);
      if (S.size == skus.length) {
        console.log("无重复");
      } else {
        this.$message.error('绑定SKU重复')
        return
      }
      this.skuFormConfig.sku[this.gIndex].relationSku = this.skus
      this.$nextTick(() => {
        // 规格列表
        const skuFormConfigAttribute = this.skuFormConfig.attribute
        skuFormConfigAttribute.forEach(firstItem => {
          firstItem.sort = firstItem.id ? Number(firstItem.id) : 1
          firstItem.itemList.forEach(secondItem => {
            secondItem.sort = secondItem.id ? Number(secondItem.id) : 1
          })
        })
        // 合并新添加的规格值
        skuFormConfigAttribute.forEach((firstItem, firstIndex) => {
          const inputValueArr = this.skuFormConfig.inputValueArr
          firstItem.itemList = firstItem.itemList.concat(inputValueArr[firstIndex]).filter(Boolean)
          firstItem.itemList = Array.from(new Set(firstItem.itemList))
        })

        const tempAttribute = this.skuFormConfig.attribute
        const skuFormConfigSku = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
        console.log(skuFormConfigSku)
        skuFormConfigSku.forEach(item => {
          console.log(item.sku)
          item.sku = item.sku.split('_')
        })
        skuFormConfigSku.forEach((firstItem, firstIndex) => {
          const attributeLength = skuFormConfigAttribute.length
          firstItem.sort = 1
          firstItem.sku.forEach((secondItem, secondIndex) => {
            switch (attributeLength) {
              case 1:
                firstItem.firstGoodsSpecName = tempAttribute[0].name
                firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
                break
              case 2:
                firstItem.firstGoodsSpecName = tempAttribute[0].name
                firstItem.secondGoodsSpecName = tempAttribute[1].name
                firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
                firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
                break
              case 3:
                firstItem.firstGoodsSpecName = tempAttribute[0].name
                firstItem.secondGoodsSpecName = tempAttribute[1].name
                firstItem.thirdGoodsSpecName = tempAttribute[2].name
                firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
                firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
                firstItem.thirdGoodsSpecItemContent = firstItem.sku[2]
                break
            }
          })
        })
        console.log(skuFormConfigSku)
        this.goods = []
        skuFormConfigSku.forEach(item => {
          let str = ''
          str = item.sku[0].replace(';', '_')
          item.skuName = str
          let obj = {
            skuName: item.skuName,
            skus: item.relationSku
          }
          this.goods.push(obj)
        })
        console.log(this.goods)
        this.goodsL = []
        let renderList = []
        this.goods.forEach(item => {
          if (item.skus) {
            item.skus.forEach(itm => {
              itm.skuName = item.skuName
              renderList.push(itm)
              this.goodsL = renderList
            })
          }

        })

      })
      this.isGoods = false
    },
    //删除sku
    deleteSku(index) {
      this.skus.splice(index, 1)
    },
    //关联商品sku添加
    addGoodsSku() {
      let obj = {
        name: '',
        status: '',
        bindGoodsSku: '',
        goodsQuantity: '',
      }
      this.skus.push(obj)
    },
    selectT(e) {
      console.log(e)
      // this.skuFormConfig.structure = []
      // if (e == '赠品') {
      //   this.skuFormConfig.structure = this.skuFormConfig.structure3
      // } else {
      //   this.skuFormConfig.structure = this.skuFormConfig.structure1
      // }
      this.$nextTick(() => {
        if (this.$refs.skuForm) {
          this.$refs.skuForm.clearValidate()
          this.$forceUpdate()
        }

      })

      // if (this.$refs.skuForm) {

      // }

    },
    back() {
      this.$router.go(-1)
    },
    changeC(val) {
      console.log(val)
      this.dialogCategory = false
      this.infoForm.categoryId = val[2]
      this.getPlatformList(val[1])
      this.categoryIdArr = val
      this.getCategoryList(val) // 获取 目类 列表
      this.getDataList(val[val.length - 1])
      this.getGoodsSaleDataList(val[val.length - 1]) // 查询指定类目的销售属性
      this.infoForm.brandId = ''
      this.getBrandList(val[val.length - 1]) // 获取 品牌 列表
    },
    toEditCategory() {
      let ids = []
      this.$route.query.category.forEach(item => {
        ids.push(item)
      })
      this.cIds = ids
      this.dialogCategory = true
    },
    qx() {
      console.log(this.showPlatform, this.infoForm.platformIds)
      for (let i = 0; i < this.infoForm.platformIds.length; i++) {
        for (let j = 0; j < this.showPlatform.length; j++) {
          if (this.infoForm.platformIds[i] == this.showPlatform[j].id) {
            this.infoForm.platformIds.splice(i, 1)
          }
        }
      }
      console.log(this.infoForm.platformIds)
      this.showPlatform = []
    },
    selectIsUp() {
      if (this.infoForm.isVerifyShelves == 2) {
        this.verificationData1()
      }
    },
    selectSettlement(e, index) {
      // console.log(e, index, Number(this.skuFormConfig.sku[index].retailPrice))
      // if (Number(this.skuFormConfig.sku[index].retailPrice) < Number(e)) {
      //   console.log(11111111)
      //   this.$refs.skuForm.init()
      //   this.skuFormConfig.sku[index].settlementPrice = ' '
      //   this.check('settlementPrice')
      // }
    },
    check(name) {
      let isError = false
      this.$refs.skuForm.validateFieldByColumns([name], errorMessage => {
        if (errorMessage) {
          isError = true
        }
      })
      if (isError) {
        console.log(88888)
        // 此处可以写验证失败后的业务代码
      }
    },
    goodRate() {
      this.$api.goodRate({}).then(res => {
        if (res.code == 0) {
          console.log(res.data)
          this.maxNormalProportion = res.data.maxNormalProportion
          this.minNormalProportion = res.data.minNormalProportion
        }
      })
    },
    getImage(val, scope) {
      console.log(val)
      console.log(this.skuFormConfig)
      // this.skuFormConfig.sku[scope.$index].Img = val
      // this.skuFormConfig.attribute[scope.$index].Img = val
      // this.infoForm.skuList[scope.$index].image = val
      console.log(scope.$index)
      scope.row.image = val
      this.$refs.skuForm.validateFieldByRows(scope.$index, 'image', () => { })
    },
    handleCheckAllChange(val) {
      console.log(val)
      let arr = []
      this.platforms.forEach(item => {
        arr.push(item.platformId)
      })
      this.infoForm.platformIds = val ? arr : [];
      this.isIndeterminate = false;
    },
    handleCheckedplatformChange(value) {
      console.log(this.infoForm.platformIds)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.platforms.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.platforms.length;
    },
    //获取平台列表
    getPlatformList(val) {
      let data = {
        id: this.$route.query.id,
        name: '',
        categoryId: val
      }
      this.$api.goodsPlatformStatus3(data).then(res => {
        this.platforms = res.data
        this.platforms.forEach(item => {
          if (this.$route.query.type == 'edit') {
            if (item.status == 1 && (item.platformName != this.infoForm.platformName)) {
              this.infoForm.platformIds.push(item.platformId)
            }
          } else {
            item.status = 0
          }

        })

        console.log(this.platforms, '22222')
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
        console.log(this.dictionaries[type])
      }).catch((err) => {
        console.log(err)
      })
    },
    selectModel() {
      if (this.infoForm.shippingTemplateId) {
        this.$api.goodsModelDetail({ id: this.infoForm.shippingTemplateId }).then(res => {
          this.detail = res.data
          this.tableData = this.detail.regions || []
          this.tableData.forEach(item => {
            Object.assign(item, { address: item.betterAddress })
            Object.assign(item, { addressData: JSON.parse(item.regionJson) })
          })
          this.tableDataF = this.detail.freeList || []
          this.tableDataF.forEach(item => {
            Object.assign(item, { address: item.betterAddress })
            Object.assign(item, { addressData: JSON.parse(item.regionJson) })
          })
          this.isShowTemplate = true
          this.infoForm.freightModeId = this.infoForm.shippingTemplateId
          if (this.detail && this.detail.calculType !== 2) {
            this.skuFormConfig.structure = this.skuFormConfig.structure2
            // this.skuFormConfig.structure = JSON.parse(JSON.stringify(this.copySkuStructure))
            // this.skuFormConfig.structure.splice(8, 1)

          } else {
            this.skuFormConfig.structure = this.skuFormConfig.structure1
            // this.skuFormConfig.structure = JSON.parse(JSON.stringify(this.copySkuStructure))
            // this.$nextTick(_ => {
            //   console.log(this.$refs.skuForm)
            //   this.$refs.skuForm.clearValidate()
            //   this.$refs.skuForm.init()
            // })
          }
          this.$forceUpdate()
        })

      } else {
        this.isShowTemplate = false
        // let scopy = this.skuFormConfig.structure
        // this.skuFormConfig.structure[8] = scopy[8]
        // return
        if (this.detail && this.detail.calculType !== 2) {
          this.skuFormConfig.structure = this.skuFormConfig.structure2
          // this.skuFormConfig.structure.splice(7, 1)
        }
      }

    },
    getList() {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        name: '',
        isSync: ''
      }
      this.$api.goodsModelList(data).then(res => {
        let obj = {
          id: '',
          name: '无'
        }
        this.models.push(obj)
        this.models = this.models.concat(res.data.list)
      })
    },
    changeImage(val) {
      console.log(val)
      this.fileList = val
    },
    showDialogSkuVisible(e, scope) {
      console.log(e, scope)
      if (scope.row.bindingSkuNo) {
        this.bindingSkuNo = scope.row.bindingSkuNo
      } else {
        this.bindingSkuNo = ''
      }
      console.log(this.skuFormConfig)
      this.dialogSkuVisible = true;
      this.skuIndex = scope.$index;
    },
    showDialogGoodsVisible(e, index) {
      console.log(e, index)
      this.gIndex = index
      this.isGoods = true
      console.log(this.skuFormConfig.sku[this.gIndex])
      if (this.skuFormConfig.sku[this.gIndex] && this.skuFormConfig.sku[this.gIndex].relationSku) {
        this.skus = this.skuFormConfig.sku[this.gIndex].relationSku
      } else {
        this.skus = []
      }


    },
    bindSku() {
      if (this.bindingSkuNo == '' || this.checknumber(this.bindingSkuNo)) {
        this.$message({
          message: '请输入正确的shu编码',
          type: 'error'
        })
        return
      }
      console.log(this.skuFormConfig, this.skuIndex)
      this.dialogSkuVisible = false;
      this.skuFormConfig.sku[this.skuIndex].bindingSkuNo = this.bindingSkuNo;
      this.$forceUpdate()
      this.bindingSkuNo = '';
    },
    checknumber(String) {
      var Letters = "1234567890";
      var i;
      var c;
      for (i = 0; i < String.length; i++) {
        c = String.charAt(i);
        if (Letters.indexOf(c) == -1) {
          return true;
        }
      }
      return false;
    },

    fetchData(type) {
      this.labelPageNo = 1
      this.labelPageSize = 10
      if (type == 'reset') {
        this.$refs['tagForm'].resetFields()
        this.labelPageNo = 1
        this.labelPageSize = 10
      } else {

      }
      this.getTagList()
    },
    //选择标签
    handleSelectTag(scope) {
      //scope.row.selected==true则是已选择，执行取消操作
      if (!scope.row.selected) {
        let data = {
          id: scope.row.id,
          tagName: scope.row.tagName
        };

        this.seletedTag.push(data)
        this.tagList[scope.$index].selected = true;
      } else {

        let idx = this.seletedTag.findIndex(item => {
          return item.id == scope.row.id
        })
        this.seletedTag.splice(idx, 1)
        this.tagList[scope.$index].selected = false;
      }
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      console.log(this.seletedTag)
      this.$forceUpdate()
    },
    //批量选择、批量取消标签
    batchSelectTag(type) {
      if (this.tagSelectionList.length == 0) {
        this.$message({
          message: '请选择标签',
          type: 'warning',
          offset: 200
        });
        return
      }
      this.tagSelectionList.forEach(item => {
        if (type == 1) {
          item.selected = true;
        } else {
          item.selected = false;
        }

      })
      let arr = this.tagList.filter(item => item.selected).map(i => {
        if (i.selected) {
          return {
            id: i.id,
            tagName: i.tagName
          }
        }
      })
      // this.seletedTag = this.seletedTag.concat(arr);
      const map = new Map();
      const newArr = this.seletedTag.concat(arr).filter(v => !map.has(v.id) && map.set(v.id, 1));

      this.seletedTag = newArr
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
    },
    //标签多选
    handleSelectionChange(val) {
      this.tagSelectionList = val;
    },
    onSizeChange(e) {
      this.labelPageSize = e;
      this.getTagList()
    },
    onCurrentChange(e) {
      this.labelPageNo = e;
      this.getTagList()
    },
    deleteTag(idx) {
      this.tagList.forEach(item => {
        if (this.seletedTag[idx].id == item.id) {
          item.selected = false;
        }
      })
      this.seletedTag.splice(idx, 1)

      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
    },
    selectTagFn(idx) {
      if (!this.tagList[idx].select) {
        this.tagList[idx].select = !this.tagList[idx].select;
        this.seletedTag.push(this.tagList[idx])
        this.infoForm.tagList = this.seletedTag.map(item => {
          return item.id
        })
      }

    },
    //获取标签数据
    getTagList() {
      let data = {
        pageNo: this.labelPageNo,
        pageSize: this.labelPageSize
      }
      data = Object.assign(data, this.tagForm)
      this.$api.selectTagDataPage(data)
        .then(res => {
          console.log(res);
          res.data.list.forEach(item => {
            item.selected = false
          })
          this.tagList = res.data.list;
          this.seletedTag.forEach(item => {
            this.tagList.forEach(el => {
              if (item.id == el.id) {
                el.selected = true;
              }
            })
          })

          this.labelTotalNum = res.data.totalNum;
        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取标签数据
    getSelectTagData() {
      this.$api.selectTagData({})
        .then(res => {
          // this.tagList = res.data;
          console.log()
          this.tagList = res.data.map(item => {
            return { tagName: item.tagName, id: item.id, select: false }
          })

        })
        .catch(err => {
          console.log(err);
        })
    },

    onChangeSkuStatus(e, row) {
      // console.log('onChangeSkuStatus', e, row)
      this.checkGift = { type: 'row', value: row }
      const skuList = this.skuList
      const nSkuIds = []
      skuList.forEach(s => {
        if (row.skuNo == s.skuNo && row.status === '0') {
          nSkuIds.push(s.id)
          this.checkGift.value['id'] = s.id
        }
      })
      if (nSkuIds.length > 0) { this.checkGiftListBySkuId(nSkuIds) }
    },
    isActionCheckGift(newVal, oldVal) {
      // const rQuery = this.$route.query
      const lastSkuStatus = this.lastSkuStatus
      const skuList = this.skuList
      const nSkuIds = []
      skuList.forEach(s => {
        newVal.sku.forEach(nItem => {
          if (nItem.status == 0 && nItem.skuNo !== '') {
            if (nItem.skuNo == s.skuNo) {
              nSkuIds.push(s.id)
            }
          }
        })
      })
      this.lastSkuStatus = nSkuIds
      console.log(nSkuIds.length, nSkuIds, lastSkuStatus.length, lastSkuStatus)
      if (nSkuIds.length > lastSkuStatus.length) {
        // this.checkGiftListBySkuId(nSkuIds)
      }
      // this.checkGiftListBySkuId (nSkuIds)
    },
    checkGiftListBySkuId(skuIds, type) {
      return new Promise((resolve, reject) => {
        this.$api.giftListBySkuId(skuIds).then((res) => {
          this.giftListByGoodId = res.data
          if (res.data.length > 0) {
            const titleArr = []
            titleArr.push(this.infoForm.name)
            if (!type) { this.showModifyState(res.data, titleArr) }
            // console.log('giftListByGoodId', res.data)
          }
          resolve(res.data)
        }).catch((err) => {
          console.log(err)
        })
      })
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'goodsList'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })

      // 查看成本价权限
      console.log('查看成本价权限', this.parArray.indexOf('eidt_chengbenjia'), this.parArray.indexOf('eidt_chengbenjia') != -1, this.parArray)
      if (this.parArray.indexOf('eidt_chengbenjia') === -1) {
        this.skuFormConfig.structure.forEach((item, index) => {
          if (item.name === 'costPrice') {
            this.skuFormConfig.structure.splice(index, 1)
          }
        })
      }
    },
    // 接受表单组件的数据
    dialogClick(val, state) {
      // console.log(val, state)
      this.formFiledDataState = state
      this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    // 初始化 信息
    initialization() {
      const queryObj = this.$route.query
      let category
      // 判断是否有 商品 ID 和 TYPE 类型 双从判断 当前页面状态
      // 获取商品信息 - 编辑模式
      if (queryObj.id && queryObj.type === 'edit') {
        // console.log(queryObj)

        this.infoForm.categoryId = this.$route.query.category[2]
        this.getPlatformList(this.infoForm.categoryId)
        this.getGoodInfo(queryObj.id)
        this.currentPageStatus = 'edit'
        this.submitButtonText = '修改商品'
      } else {
        this.currentPageStatus = 'add'
        this.submitButtonText = '发布商品'
        this.copySkuStructure = JSON.parse(JSON.stringify(this.skuFormConfig.structure))
        this.skuFormConfig.structure.splice(10, 1)
        // 添加模式
        if (queryObj && queryObj.category) { category = this.$route.query.category }
        if (category && category.length !== 0) {
          this.infoForm.categoryId = category[2]
          let val = category[1]
          this.getPlatformList(val)
          this.categoryIdArr = category
          this.getCategoryList(category) // 获取 目类 列表
          // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
          this.getDataList(category[category.length - 1])
          this.getGoodsSaleDataList(category[category.length - 1]) // 查询指定类目的销售属性
          this.getBrandList(category[category.length - 1]) // 获取 品牌 列表
          // 初始化 上 下架 状态 , 为了等待数据返回添加一个 setTimeout
          setTimeout(() => {
            // 设置 商品类型、 是否上架 默认值
            // if (this.dictionaries.goods_type.length !== 0) { this.infoForm.goodsType = this.dictionaries.goods_type[0].dictName }
            if (this.dictionaries.sale_status.length !== 0) { this.infoForm.status = this.dictionaries.sale_status[1].dictName }
          }, 1000)
        } else {
          console.log('还没选择商品分类')
          this.$alert('还没选择商品分类', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action)
              this.toOtherPages('goodsCategoryEdit')
            }
          })
        }
      }
    },
    addTag() {
      this.showTagDialog = true
      // this.seletedTag = []
    },
    skuItemHandle(item) {
      let tempSkuName = ''; let differenceStr = ''
      if (item.secondGoodsSpecItemId && item.thirdGoodsSpecItemId) {
        tempSkuName = `${item.firstGoodsSpecItemContent},${item.secondGoodsSpecItemContent},${item.thirdGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId},${item.secondGoodsSpecItemId},${item.thirdGoodsSpecItemId}`
      } else if (item.secondGoodsSpecItemId) {
        tempSkuName = `${item.firstGoodsSpecItemContent},${item.secondGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId},${item.secondGoodsSpecItemId}`
      } else {
        tempSkuName = `${item.firstGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId}`
      }
      const tempSKU = {
        id: item.id,
        sku: tempSkuName,
        difference: `${differenceStr}`,
        skuNo: item.skuNo,
        stock: item.stock,
        status: item.status,
        costPrice: item.costPrice,
        marketPrice: item.marketPrice,
        retailPrice: item.retailPrice,
        Img: item.Img,
        weight: item.weight,
        initSellNum: item.initSellNum
      }
      return tempSKU
    },
    // 获取 商品信息
    getGoodInfo(goodsId) {
      console.log(this.skuFormConfig)
      this.breadcrumbTitle = '编辑商品'
      const params = { id: goodsId }
      this.$api.goodsDetail(params).then((res) => {
        const categoryId = res.data.categoryInfo.id
        this.infoForm = Object.assign(this.infoForm, res.data)
        this.fileList = this.infoForm.imageList
        this.infoForm.brandId = ''
        // this.infoForm.brandId = String(res.data.brandId)
        // 回显类目ID
        // this.infoForm.categoryId = categoryId
        this.infoForm.isVerifyShelves = String(this.infoForm.isVerifyShelves)
        this.infoForm.isShelvesAddedPlatform = String(this.infoForm.isShelvesAddedPlatform)
        this.infoForm.shippingTemplateId = Number(res.data.freightModeId ? res.data.freightModeId : '')
        if (this.infoForm.shippingTemplateId == 0) { this.infoForm.shippingTemplateId = '' }
        this.selectModel()
        // if (!this.detail && this.detail.calculType !== 2) {
        //   this.skuFormConfig.structure.splice(8, 1)
        // }

        // this.skuFormConfig.structure.splice(8, 1)

        /*
        this.infoForm.imageList.forEach(item => {
          if (item.url && item.url.indexOf('http://fenxiao.muruji.com/') !== 0) { item.url = this.ImgHttps + item.url }
        })
        */
        setTimeout(() => {
          // 回显 商品类型
          // if (this.dictionaries.goods_type.length !== 0) {
          //   const goodsTypeObj = this.dictionaries.goods_type.find(e => { return e.dictId === this.infoForm.goodsType })
          //   if (goodsTypeObj) { this.infoForm.goodsType = goodsTypeObj.dictName }
          // }
          // 回显 上架 与 下架状态
          if (this.dictionaries.sale_status.length !== 0) {
            const statusObj = this.dictionaries.sale_status.find(e => { return e.dictId === this.infoForm.status.toString() })
            if (statusObj) { this.infoForm.status = statusObj.dictName }
          }
        }, 1000)
        // console.log(this.infoForm.goodsType, '55555')
        // if (this.infoForm.goodsType == '3') {
        //   this.skuFormConfig.structure = this.skuFormConfig.structure3
        // }
        // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
        this.infoForm.categoryId = this.$route.query.category[2]
        this.getPlatformList(this.$route.query.category[1])
        this.categoryIdArr = this.$route.query.category
        this.getCategoryList(this.$route.query.category) // 获取 目类 列表
        this.getDataList(this.$route.query.category[this.$route.query.category.length - 1])
        this.getGoodsSaleDataList(this.$route.query.category[this.$route.query.category.length - 1]) // 查询指定类目的销售属性
        this.getBrandList(this.$route.query.category[this.$route.query.category.length - 1]) // 获取 品牌 列表
        this.getSkuNo(goodsId) // 生成sku编码

        // 查询指定类目的销售属性
        this.getGoodsSaleDataList(categoryId, res.data.specList, res.data.skuList)
        const tempskuList = []
        res.data.skuList.forEach(e => {
          const itemHandle = this.skuItemHandle(e)
          tempskuList.push(itemHandle)
        })
        this.skuList = tempskuList
        //回显平台
        // this.platformList.forEach(item => {
        //   if (item.status != 4) {
        //     this.infoForm.platformIds.push(item.platformId)
        //   }
        // })
        if (this.platformList)
          this.editTagList = res.data.tagList || [];
        if (this.tagList.length > 0) {
          console.log(555555)
          this.tagList.forEach(item => {
            this.editTagList.forEach(el => {
              if (el.id == item.id) {
                item.selected = true;
              }
            })
          })
          this.seletedTag = this.editTagList.map(item => {
            return {
              id: item.id,
              tagName: item.name
            }
          })
          this.infoForm.tagList = this.seletedTag.map(item => {
            return item.id
          })
        }
        // this.skuItemHandle()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList(categoryInfo, categoryInfoList) {
      // console.log(categoryInfo)
      const params = { pageNo: 1, pageSize: 999 }
      this.$api.categoryList(params).then((res) => {
        this.categoryList = res.data.list
        this.onChangeEditClassId(categoryInfo, categoryInfoList)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
    getDataList(categoryId, attrGroupList) {
      const params = { categoryId }
      this.$api.goodsAttrDataList(params).then((res) => {
        const resData = res.data
        const arr = []
        // debugger
        resData.forEach(firstItem => {
          const obj = {
            name: firstItem.name,
            id: firstItem.id,
            // 表单宽度  表单的list 表单的匹配规则
            formconfig: { labeWidth: 100, itemList: [], rules: {} },
            // 表单提交数据，注：如果类型是checkbox，必须foemData里边提前声明数组
            formData: {}
          }
          firstItem.itemList.forEach(secondItem => {
            // 字典 goods_attr_type
            // 1、文本 2、单选  3、多选  4、时间
            const type = Number(secondItem.typeFlag)
            let propId
            /*
            // 修改模式下，需要多添加一个 ID
            if(this.currentPageStatus == "edit"){
              attrGroupList.forEach( aItem => {
                aItem.itemList.forEach( aItemList => {
                  if(aItem.id == firstItem.id && aItemList.id == secondItem.id){
                    propId = `value-${firstItem.id}-${secondItem.id}-${aItemList.id}`;
                  }
                })
              })
            } else {
              propId = `value-${firstItem.id}-${secondItem.id}`;
            }
            */
            propId = `value-${firstItem.id}-${secondItem.id}`
            switch (type) {
              case 1: // 文本
                obj.formconfig.itemList.push({ type: 'input', prop: propId, placeholder: '请输入内容', label: secondItem.name })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请输入内容', trigger: 'blur' }] })
                break
              case 2: // 单选
                const radiosArr = []
                /*
              secondItem.itemList.forEach( radiosItem => { radiosArr.push({label:radiosItem.label,value:radiosItem.id}) })
              obj.formconfig.itemList.push( { type:'radio', prop:propId, label:secondItem.name, radios:radiosArr } )
              obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId] :[{ required: secondItem.requiredFlag == 0 ? false :true, message: '请选择内容', trigger: 'change' }]});
              */
                secondItem.itemList.forEach(item => { radiosArr.push({ label: item.label, value: item.id }) })
                obj.formconfig.itemList.push({ type: 'select', prop: propId, label: secondItem.name, option: radiosArr, isMultiple: false })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请选择内容', trigger: 'change' }] })
                break
              case 3: // 多选
                // debugger
                const checkboxArr = []
                /*
              secondItem.itemList.forEach( checkboxItem => { checkboxArr.push({label:checkboxItem.label,value:checkboxItem.id}) })
              obj.formconfig.itemList.push( { type:'checkbox',prop:propId,label:secondItem.name, checkboxs:checkboxArr } )
              obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId] :[{ type: 'array', required: secondItem.requiredFlag == 0 ? false :true, message: '请至少选择一个内容', trigger: 'change' }]});
              */
                secondItem.itemList.forEach(checkboxItem => { checkboxArr.push({ label: checkboxItem.label, value: checkboxItem.id }) })
                obj.formconfig.itemList.push({ type: 'select', prop: propId, label: secondItem.name, option: checkboxArr, isMultiple: true, isCollapseTags: true })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请至少选择一个内容', trigger: 'blur' }] })
                // 表单提交数据，注：如果类型是checkbox，必须foemData里边提前声明数组
                // obj.formData = Object.assign(obj.formData, {[propId]:[]})
                break
              case 4: // 时间
                obj.formconfig.itemList.push({ type: 'datapicker', prop: propId, placeholder: '请选择日期', label: secondItem.name })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ type: 'string', required: secondItem.requiredFlag != 0, message: '请选择日期', trigger: 'change' }] })
                break
              default: // 出错 - 不在设计范围
                console.log(typeof type, type)
              // 默认代码块
            }
          })
          arr.push(obj)
        })
        this.goodsAttrData = arr
        // 编辑状态下 类目属性 回显 值
        if (this.currentPageStatus === 'edit') { this.showGoodsAttrValue(arr) }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 编辑状态下 类目属性 回显 值
    showGoodsAttrValue(arr) {
      const attrGroupList = this.infoForm.attrGroupList
      // const original = [...arr]
      // this.goodsAttrData[0].formData["value-15-20"] = "20"
      // 准备匹配值
      attrGroupList.forEach(firstItem => {
        firstItem.itemList.forEach(secondItem => {
          secondItem.matchValue = `value-${firstItem.id}-${secondItem.id}`
        })
      })
      this.goodsAttrData.forEach((firstItem, firstIndex) => {
        firstItem.formconfig.itemList.forEach(secondItem => {
          attrGroupList.forEach(attFirstItem => {
            attFirstItem.itemList.forEach(attSecondItem => {
              if (attSecondItem.matchValue == secondItem.prop) {
                // 1、文本 2、单选  3、多选  4、时间
                switch (attSecondItem.typeFlag) {
                  case '1': // 文本
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  case '2': // 单选
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  case '3': // 多选
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  default: // 时间
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = attSecondItem.attrValueContent
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                }
              }
            })
          })
        })
      })
      // console.log(this.goodsAttrData[1].formData["value-15-20"])
    },
    // 选择销售属性
    onChangeGoodsSaleDataListValue(selectArr) {
      // sessionStorage.setItem('saleDataListValue', JSON.stringify(this.goodsSaleDataListValue))
      // this.skuFormConfig.attribute.splice(fatherIndex, 1)
      if (this.skuFormConfig.attribute.length >= 3) {
        console.log(this.skuFormConfig.attribute.length)
        console.log(selectArr.length)
        if (selectArr.length === 3) { selectArr.splice(3) }
        if (selectArr.length === 2) { selectArr.splice(2) }
        if (selectArr.length === 1) { selectArr.splice(1) }
      }
      this.goodsSaleDataListValue = selectArr
      const sourceAttribute = this.skuFormConfig.sourceAttribute
      const arr = []
      selectArr.forEach(item => {
        const matching = sourceAttribute.find(e => { return e.id === item })
        // console.log(matching)
        arr.push(matching)
      })
      const tempAttribute = []
      this.skuFormConfig.attribute.forEach(item => {
        if (item.id === undefined) {
          tempAttribute.push(item)
        }
      })
      this.skuFormConfig.attribute = tempAttribute
      // this.skuFormConfig.attribute = arr // SKU已选属性
      this.skuFormConfig.attribute = Array.from(new Set(this.skuFormConfig.attribute.concat(arr)))
      // ============== 初始 空数组，使用在添加新的属性  ==============
      this.skuFormConfig.inputValueArr = []
      this.skuFormConfig.inputValueArrTemp = []
      this.skuFormConfig.attribute.forEach((item, index) => {
        // this.skuFormConfig.inputValueArr.push({ name: '', item: [], itemList: [] })
        this.skuFormConfig.inputValueArr.push([])
        this.skuFormConfig.inputValueArrTemp.push('')
      })
      this.$nextTick(_ => {
        this.$refs.skuForm.init()
        console.log(this.skuFormConfig.inputValueArrTemp)
      })
    },
    onExceed() {
      selectArr.splice(selectArr.length - 1, 1)
      this.goodsSaleDataListValue = selectArr
      console.log('已经超出', this.goodsSaleDataListValue)
      console.log('已经超出', this.skuFormConfig.attribute)
    },
    // 查询指定类目的销售属性
    getGoodsSaleDataList(categoryId, goodsSpecList, goodsSpecTable) {
      const params = { categoryId }
      this.$api.categorySalesPecDetail(params).then((res) => {
        // ============== 初始SKU可选属性 ==============
        const modifySpecList = res.data
        // 修改 初始化 key 为 组件 所需要 key
        modifySpecList.forEach((e) => {
          const itemArr = []
          e.itemList.forEach((itemList) => {
            itemArr.push(itemList.content)
          })
          e.item = itemArr
        })
        this.skuFormConfig.sourceAttribute = Array.from(new Set(modifySpecList)) // SKU可选属性
        // ============== 初始 回显 已选 SKU 值  ==============
        if (goodsSpecList && goodsSpecList.length !== 0) {
          goodsSpecList = goodsSpecList.sort(function (a, b) { return a.id - b.id })
          goodsSpecList.forEach(firstItem => {
            const itemArr = []
            firstItem.itemList.forEach(secondItem => {
              itemArr.push(secondItem.content)
            })
            firstItem.item = itemArr
          })
          this.skuFormConfig.attribute = goodsSpecList
          const tempSourceAttribute = Array.from(new Set(this.skuFormConfig.sourceAttribute.concat(goodsSpecList).filter(Boolean)))

          /**
           * 删除数组对象中重复的对象
           * arr: 源数组   filterField: 需要删除的重复字段，注意是字符串类型
           * 返回一个过滤好的，没有重复该字段filterField的数组
           * */
          const filterArrObj = (arr, filterField) => {
            const newArr = arr.reduce((pre, cur) => pre.some(item => item[filterField] == cur[filterField])
              ? pre : [...pre, cur], [])
            return newArr
          }
          this.skuFormConfig.sourceAttribute = filterArrObj(tempSourceAttribute, 'name')
          console.log(this.skuFormConfig)
          // const echoSpecList = []
        }

        if (goodsSpecTable && goodsSpecTable.length !== 0) {
          goodsSpecTable.forEach(item => {
            const arr = []
            arr.push(item.firstGoodsSpecItemContent)
            if (item.secondGoodsSpecItemContent) { arr.push(item.secondGoodsSpecItemContent) }
            if (item.thirdGoodsSpecItemContent) { arr.push(item.thirdGoodsSpecItemContent) }
            item.sku = arr.join(';')
            item.status = item.status.toString()
          })
          this.skuFormConfig.sku = Array.from(new Set(goodsSpecTable))
          // 还原数据时，SKU组件将 ID 过滤掉，先将 数据缓存到本地，提交数据时使用
          sessionStorage.setItem('skuFormConfigSku', JSON.stringify(goodsSpecTable))
        }
        /*
        // SKU已选属性 编辑模式下使用
        if (this.currentPageStatus !== 'add') {
          this.skuFormConfig.attribute = Array.from(new Set(selectedSku)) // SKU已选属性
          this.skuFormConfig.sku = Array.from(new Set(modifySpecTable)) // SKU数据
          this.$nextTick(_ => {
            this.$refs.skuForm.init()
            // 提交数据时使用
            sessionStorage.setItem('skuFormConfigSku', JSON.stringify(modifySpecTable))
          })
        }
        */
        // ============== 初始 空数组，使用在添加新的属性  ==============
        this.skuFormConfig.attribute.forEach((item, index) => {
          this.skuFormConfig.inputValueArr.push([])
          this.skuFormConfig.inputValueArrTemp.push('')
        })
        console.log('表刚刚改', this.skuFormConfig)
        // console.log(this.skuFormConfig)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取 品牌 列表
    getBrandList(categoryId) {
      const params = { pageNo: 1, pageSize: 999, categoryId }
      this.$api.brandCommList1().then((res) => {
        this.brandList = res.data
        this.brandList.push({
          id: '-1',
          name: '其它'
        })
        console.log(this.brandList)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      // console.log(val)
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 修改 回显 classId
    onChangeEditClassId(categoryIdInfo, categoryInfoList) {
      // debugger
      let categoryId
      let categoryArrStr = ''
      if (typeof categoryIdInfo === 'string') {
        categoryId = categoryIdInfo
      } else {
        categoryId = categoryIdInfo[categoryIdInfo.length - 1]
      }
      const categoryList = this.categoryList
      if (categoryList.length < 0) { console.log('categoryList没到位！', categoryList) }
      const arr = []
      categoryList.forEach((firstItem, firstIndex) => {
        if (firstItem.id === categoryId) {
          console.log(firstItem.label)
          categoryArrStr = firstItem.label
          arr.push(firstItem.id)
          return
        }
        if (firstItem.children) {
          firstItem.children.forEach((secondItem, secondIndex) => {
            if (secondItem.id === categoryId) {
              categoryArrStr = `${firstItem.label} > ${secondItem.label}`
              arr.push(firstItem.id)
              arr.push(secondItem.id)
              return
            }
            if (secondItem.children) {
              secondItem.children.forEach((thirdItem, thirdIndex) => {
                if (thirdItem.id === categoryId) {
                  categoryArrStr = `${firstItem.label} > ${secondItem.label} > ${thirdItem.label}`
                  arr.push(firstItem.id)
                  arr.push(secondItem.id)
                  arr.push(thirdItem.id)
                  return
                }
              }) // third end
            }
          }) // second end
        }
      }) // first end

      if (categoryArrStr.length == '' || categoryArrStr.length < 0) {
        if (categoryInfoList) {
          categoryInfoList.reverse()
          const tempArr = []
          categoryInfoList.forEach(item => {
            tempArr.push(item.categoryName)
          })
          categoryArrStr = tempArr.join(' > ')
          console.log(categoryArrStr)
        } else {
          console.log('还没选择商品分类1', categoryArrStr)
          this.$alert('还没选择商品分类', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action)
              this.toOtherPages('goodsCategoryEdit')
            }
          })
        }
      }
      this.categoryArrStr = categoryArrStr
    },
    // 生成sku编码
    getSkuNo(id) {
      // 主键id请求
      const params = { id }
      this.$api.gkuNoByGoodId(params).then((res) => {
        this.maxSkuNo = Number(res.data) // 获取 的 skuNo 转数字，方便后面使用可以自增
      }).catch((err) => {
        console.log(err)
      })
    },
    // 表单规则验证
    async verificationData1() {
      // if (this.infoForm.name && this.infoForm.name !== '' && this.currentPageStatus === 'add') {
      const infoForm = this.infoForm
      console.log(infoForm)
      if (infoForm.name && infoForm.name !== '') {
        const goodsId = infoForm.id || ''
        const isRepeatGoodsName = await this.checkGoodsName(infoForm.name, goodsId)
        // console.log('isRepeatGoodsName', isRepeatGoodsName)
        if (isRepeatGoodsName.code !== 0) {
          // this.$message.warning('商品名称有重名，请重新输入！')
          return console.log("商品有重名")
        }
      }
      console.log(8888888888)
      if (this.fileList.length == 0) {
        this.$message.warning('请上传商品图片')
        return
      }
      if (this.infoForm.details == '') {
        this.$message.warning('请填写商品详情')
        return
      }
      if (this.skuFormConfig.attribute.length == 0) {
        this.$message.warning('请添加规格')
        return
      }
      // if (this.infoForm.platformIds == []) {
      //   this.$message.warning('请选择上架平台')
      //   return
      // }
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {

          this.goodsAttrData.forEach(item => {
            const formName = 'formAttr' + item.id
            this.$refs[formName][0].submitForm('ruleForm')
          })
          console.log(9999)
          this.$refs.skuForm.validate(valid => {
            if (valid) {
              // this.$message.success('skuForm验证通过')
              // 图片信息检查
              console.log(this.fileList)
              for (let i = 0; i < this.fileList.length; i++) {
                if (i == 0) {
                  this.fileList[i].mainFlag = true
                } else {
                  this.fileList[i].mainFlag = false
                }
              }
              this.infoForm.imageList = this.fileList
              if (this.infoForm.imageList.length !== 0) {
                if (this.formFiledDataState) {
                  this.submitDate1()
                } else {
                  this.$message.warning('请完善类目属性再提交！')
                }
              } else {
                this.$message.warning('请完善图片信息再提交！')
              }
            } else {
              // this.$message.warning('skuForm验证失败')
              return
            }
          })
        } else {
          this.$message.warning('请完善信息再提交！')
          console.log('error submit!!')
          return false
        }
      })
    },
    // 提交 数据
    async submitDate1() {
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      const params = Object.assign({}, this.infoForm)
      const formFiledData = Object.assign({}, this.formFiledData) // 接受表单组件的数据
      const attrListTemp = [] 	// 商品属性组列表
      // const goodsAttrDataList = this.goodsAttrDataList // 类目商品属性库列表
      // const goods_typeFindObj = this.dictionaries.goods_type.find(e => { return e.dictName === this.infoForm.goodsType })
      // if (goods_typeFindObj) { params.goodsType = Number(goods_typeFindObj.dictId) }
      const statusFindObj = this.dictionaries.sale_status.find(e => { return e.dictName === this.infoForm.status })
      if (statusFindObj) { params.status = statusFindObj.dictId }
      /*
      // 接受 表单组件 的数据 整理
      attrGroupId:1,//	是	int	属性组id
      attrId:1,	//是	int	属性id
      goodsAttrItemId:1,	//否	int	属性值id（下拉）
      attrValueContent:1,//	否	String	属性值内容（日期、填空）
      */
      for (const item in formFiledData) {
        const itemTemp = item.split('-')
        const objTemp = { attrGroupId: Number(itemTemp[1]), attrId: Number(itemTemp[2]), goodsAttrItemId: Number(formFiledData[item]), attrValueContent: JSON.stringify(formFiledData[item]) }
        // console.log(itemTemp)
        attrListTemp.push(objTemp)
      }
      params.attrList = attrListTemp // 商品属性组列表
      // 规格列表
      const skuFormConfigAttribute = this.skuFormConfig.attribute
      skuFormConfigAttribute.forEach(firstItem => {
        firstItem.sort = firstItem.id ? Number(firstItem.id) : 1
        firstItem.itemList.forEach(secondItem => {
          secondItem.sort = secondItem.id ? Number(secondItem.id) : 1
        })
      })

      // 合并新添加的规格值
      skuFormConfigAttribute.forEach((firstItem, firstIndex) => {
        const inputValueArr = this.skuFormConfig.inputValueArr
        firstItem.itemList = firstItem.itemList.concat(inputValueArr[firstIndex]).filter(Boolean)
        firstItem.itemList = Array.from(new Set(firstItem.itemList))
      })
      params.specList = skuFormConfigAttribute

      const tempAttribute = this.skuFormConfig.attribute
      const skuFormConfigSku = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
      console.log(skuFormConfigSku)
      skuFormConfigSku.forEach(item => {
        console.log(item.sku)
        item.sku = item.sku.split(';')
      })
      skuFormConfigSku.forEach((firstItem, firstIndex) => {
        const attributeLength = skuFormConfigAttribute.length
        firstItem.sort = 1
        firstItem.sku.forEach((secondItem, secondIndex) => {
          switch (attributeLength) {
            case 1:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              break
            case 2:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              break
            case 3:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.thirdGoodsSpecName = tempAttribute[2].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              firstItem.thirdGoodsSpecItemContent = firstItem.sku[2]
              break
          }
        })
      })
      const currentPageStatus = this.currentPageStatus
      // 编辑时，给SKU添加ID   获取 缓存 数据 匹配 ID
      if (currentPageStatus === 'edit') {
        // console.log("页面状态", typeof currentPageStatus, currentPageStatus)
        // const skuFormConfigSkuLs = Array.from(new Set(JSON.parse(sessionStorage.getItem('skuFormConfigSku'))))
        const skuFormConfigSkuls = JSON.parse(sessionStorage.getItem('skuFormConfigSku'))
        skuFormConfigSku.forEach(item => {
          skuFormConfigSkuls.forEach(itemLs => {
            if (item.skuNo === itemLs.skuNo) {
              item.id = itemLs.id
            }
          })
        })
      }

      // 添加模式下 添加 skuNo 编号
      if (currentPageStatus === 'add') {
        skuFormConfigSku.forEach((item, index) => {
          item.skuNo = this.maxSkuNo
          item.skuNo = item.skuNo < 10 ? '0' + item.skuNo.toString() : item.skuNo.toString()
          this.maxSkuNo++
          item.status = 1
        })
      }

      // 复查 skuNo
      skuFormConfigSku.forEach((item, index) => {
        if (!item.relationSku) {
          item.relationSku = []
        }
        if (item.skuNo === '' || item.skuNo === undefined || item.skuNo === null) {
          // 生成sku编码
          const newSkuNo = this.maxSkuNo
          item.skuNo = newSkuNo < 10 ? '0' + newSkuNo.toString() : newSkuNo.toString()
          this.maxSkuNo++
        }
        delete item.sku
      })

      params.skuList = skuFormConfigSku
      console.log(params.skuList)
      // 图片列表 ，设置第一张图为主图
      if (params.imageList && params.imageList[0]) { params.imageList[0].mainFlag = 1 }
      // 删除多余参数属性
      delete params.maxPrice
      delete params.minPrice

      const tempGiftIdArr = []
      /**     checkGift By sku     **/
      const disableSkuArrId = []
      if (params.skuList.length > 0) {
        params.skuList.forEach(e => {
          if (e.status === '0') { disableSkuArrId.push(e.id) }
        })
      }

      if (disableSkuArrId.length > 0 && this.currentPageStatus === 'edit') {
        const giftList = await this.checkGiftListBySkuId(disableSkuArrId, 'submit')
        console.log('giftList', giftList)
        if (giftList.length > 0) {
          giftList.forEach(e => { tempGiftIdArr.push(e.id) })
        }
      }
      /**    checkGift By sku end     **/

      /**    checkGift By Goods     **/
      if (params.status === '0' && params.id) {
        const idsArr = params.id ? [params.id] : []
        const giftListG = await this.checkGiftListByGoodId(idsArr, 'submit')
        if (giftListG.length > 0) {
          giftListG.forEach(e => { tempGiftIdArr.push(e.id) })
        }
      }
      /**    checkGift By Goods end     **/

      /**    action GiftPutOff     **/
      const actionArr = Array.from(new Set(tempGiftIdArr))
      // return console.log('actionArr', actionArr)
      if (actionArr.length > 0) { await this.onGiftPutOff(actionArr) }
      /**    action GiftPutOff end     **/

      // return console.log('提交数据', params.skuList)
      // return
      params.status = '1'
      params.isRollback = 1
      console.log(params)
      if (this.currentPageStatus === 'add') {
        // 添加
        this.$api.goodPlatformProportions(params).then((res) => {
          if (res.code === 0) {
            console.log(res.data)
            let reMap = res.data.reMap
            let newArray = [];
            for (let key in reMap) {
              let parts = key.split('---');
              newArray.push({
                id: parts[1],
                name: parts[0],
                price: reMap[key]
              })
            }
            console.log(newArray)
            this.showPlatform = newArray
            // this.$message({ type: 'success', message: '添加商品成功!' })
            // this.$notify({
            //   title: '成功',
            //   message: '添加商品成功!',
            //   type: 'success',
            //   duration: 3000
            // })
            // this.toOtherPages('goodsList')
          }
        }).catch((err) => {
          console.log(err)
        })




      } else {
        // 编辑
        delete params.attrGroupList
        delete params.categoryInfo
        delete params.goodsNo
        this.$api.goodPlatformProportions(params).then((res) => {
          if (res.code === 0) {
            console.log(res.data)
            let reMap = res.data.reMap
            let newArray = [];
            for (let key in reMap) {
              let parts = key.split('---');
              newArray.push({
                id: parts[1],
                name: parts[0],
                price: reMap[key]
              })
            }
            console.log(newArray)
            this.showPlatform = newArray
            // this.$message({ type: 'success', message: '添加商品成功!' })
            // this.$notify({
            //   title: '成功',
            //   message: '添加商品成功!',
            //   type: 'success',
            //   duration: 3000
            // })
            // this.toOtherPages('goodsList')
          }
        }).catch((err) => {
          console.log(err)
        })

      }
    },
    // 表单规则验证
    async verificationData() {
      // if (this.infoForm.name && this.infoForm.name !== '' && this.currentPageStatus === 'add') {
      const infoForm = this.infoForm
      console.log(infoForm)
      if (infoForm.name && infoForm.name !== '') {
        const goodsId = infoForm.id || ''
        const isRepeatGoodsName = await this.checkGoodsName(infoForm.name, goodsId)
        // console.log('isRepeatGoodsName', isRepeatGoodsName)
        if (isRepeatGoodsName.code !== 0) {
          // this.$message.warning('商品名称有重名，请重新输入！')
          return console.log("商品有重名")
        }
      }
      console.log(8888888888)
      if (this.fileList.length == 0) {
        this.$message.warning('请上传商品图片')
        return
      }
      if (this.infoForm.details == '') {
        this.$message.warning('请填写商品详情')
        return
      }
      if (this.skuFormConfig.attribute.length == 0) {
        this.$message.warning('请添加规格')
        return
      }
      // if (this.infoForm.platformIds == []) {
      //   this.$message.warning('请选择上架平台')
      //   return
      // }
      if (this.infoForm.isVerifyShelves == '') {
        this.$message.warning('请选择平台是否审核上架')
        return
      }
      if (this.infoForm.isShelvesAddedPlatform == 0) {
        this.$message.warning('请选择是否上架后续新增平台')
        return
      }
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {

          this.goodsAttrData.forEach(item => {
            const formName = 'formAttr' + item.id
            this.$refs[formName][0].submitForm('ruleForm')
          })
          console.log(9999)
          this.$refs.skuForm.validate(valid => {
            if (valid) {
              // this.$message.success('skuForm验证通过')
              // 图片信息检查
              console.log(this.fileList)
              for (let i = 0; i < this.fileList.length; i++) {
                if (i == 0) {
                  this.fileList[i].mainFlag = true
                } else {
                  this.fileList[i].mainFlag = false
                }
              }
              this.infoForm.imageList = this.fileList
              if (this.infoForm.imageList.length !== 0) {
                if (this.formFiledDataState) {
                  this.submitDate()
                } else {
                  this.$message.warning('请完善类目属性再提交！')
                }
              } else {
                this.$message.warning('请完善图片信息再提交！')
              }
            } else {
              // this.$message.warning('skuForm验证失败')
              return
            }
          })
        } else {
          this.$message.warning('请完善信息再提交！')
          console.log('error submit!!')
          return false
        }
      })
    },
    // 提交 数据
    async submitDate() {
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      const params = Object.assign({}, this.infoForm)
      const formFiledData = Object.assign({}, this.formFiledData) // 接受表单组件的数据
      const attrListTemp = [] 	// 商品属性组列表
      // const goodsAttrDataList = this.goodsAttrDataList // 类目商品属性库列表
      // const goods_typeFindObj = this.dictionaries.goods_type.find(e => { return e.dictName === this.infoForm.goodsType })
      // if (goods_typeFindObj) { params.goodsType = Number(goods_typeFindObj.dictId) }
      const statusFindObj = this.dictionaries.sale_status.find(e => { return e.dictName === this.infoForm.status })
      if (statusFindObj) { params.status = statusFindObj.dictId }
      /*
      // 接受 表单组件 的数据 整理
      attrGroupId:1,//	是	int	属性组id
      attrId:1,	//是	int	属性id
      goodsAttrItemId:1,	//否	int	属性值id（下拉）
      attrValueContent:1,//	否	String	属性值内容（日期、填空）
      */
      for (const item in formFiledData) {
        const itemTemp = item.split('-')
        const objTemp = { attrGroupId: Number(itemTemp[1]), attrId: Number(itemTemp[2]), goodsAttrItemId: Number(formFiledData[item]), attrValueContent: JSON.stringify(formFiledData[item]) }
        // console.log(itemTemp)
        attrListTemp.push(objTemp)
      }
      params.attrList = attrListTemp // 商品属性组列表
      // 规格列表
      const skuFormConfigAttribute = this.skuFormConfig.attribute
      skuFormConfigAttribute.forEach(firstItem => {
        firstItem.sort = firstItem.id ? Number(firstItem.id) : 1
        firstItem.itemList.forEach(secondItem => {
          secondItem.sort = secondItem.id ? Number(secondItem.id) : 1
        })
      })

      // 合并新添加的规格值
      skuFormConfigAttribute.forEach((firstItem, firstIndex) => {
        const inputValueArr = this.skuFormConfig.inputValueArr
        firstItem.itemList = firstItem.itemList.concat(inputValueArr[firstIndex]).filter(Boolean)
        firstItem.itemList = Array.from(new Set(firstItem.itemList))
      })
      params.specList = skuFormConfigAttribute

      const tempAttribute = this.skuFormConfig.attribute
      const skuFormConfigSku = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
      console.log(skuFormConfigSku)
      skuFormConfigSku.forEach(item => {
        console.log(item.sku)
        item.sku = item.sku.split(';')
      })
      skuFormConfigSku.forEach((firstItem, firstIndex) => {
        const attributeLength = skuFormConfigAttribute.length
        firstItem.sort = 1
        firstItem.sku.forEach((secondItem, secondIndex) => {
          switch (attributeLength) {
            case 1:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              break
            case 2:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              break
            case 3:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.thirdGoodsSpecName = tempAttribute[2].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              firstItem.thirdGoodsSpecItemContent = firstItem.sku[2]
              break
          }
        })
      })
      const currentPageStatus = this.currentPageStatus
      // 编辑时，给SKU添加ID   获取 缓存 数据 匹配 ID
      if (currentPageStatus === 'edit') {
        // console.log("页面状态", typeof currentPageStatus, currentPageStatus)
        // const skuFormConfigSkuLs = Array.from(new Set(JSON.parse(sessionStorage.getItem('skuFormConfigSku'))))
        const skuFormConfigSkuls = JSON.parse(sessionStorage.getItem('skuFormConfigSku'))
        skuFormConfigSku.forEach(item => {
          skuFormConfigSkuls.forEach(itemLs => {
            if (item.skuNo === itemLs.skuNo) {
              item.id = itemLs.id
            }
          })
        })
      }

      // 添加模式下 添加 skuNo 编号
      if (currentPageStatus === 'add') {
        skuFormConfigSku.forEach((item, index) => {
          item.skuNo = this.maxSkuNo
          item.skuNo = item.skuNo < 10 ? '0' + item.skuNo.toString() : item.skuNo.toString()
          this.maxSkuNo++
          // item.status = 1
        })
      }

      // 复查 skuNo
      skuFormConfigSku.forEach((item, index) => {
        if (!item.relationSku) {
          item.relationSku = []
        }
        if (item.skuNo === '' || item.skuNo === undefined || item.skuNo === null) {
          // 生成sku编码
          const newSkuNo = this.maxSkuNo
          item.skuNo = newSkuNo < 10 ? '0' + newSkuNo.toString() : newSkuNo.toString()
          this.maxSkuNo++
        }
        delete item.sku
      })

      params.skuList = skuFormConfigSku
      console.log(params.skuList)
      // 图片列表 ，设置第一张图为主图
      if (params.imageList && params.imageList[0]) { params.imageList[0].mainFlag = 1 }
      // 删除多余参数属性
      delete params.maxPrice
      delete params.minPrice

      const tempGiftIdArr = []
      /**     checkGift By sku     **/
      const disableSkuArrId = []
      if (params.skuList.length > 0) {
        params.skuList.forEach(e => {
          if (e.status === '0') { disableSkuArrId.push(e.id) }
        })
      }

      if (disableSkuArrId.length > 0 && this.currentPageStatus === 'edit') {
        const giftList = await this.checkGiftListBySkuId(disableSkuArrId, 'submit')
        console.log('giftList', giftList)
        if (giftList.length > 0) {
          giftList.forEach(e => { tempGiftIdArr.push(e.id) })
        }
      }
      /**    checkGift By sku end     **/

      /**    checkGift By Goods     **/
      if (params.status === '0' && params.id) {
        const idsArr = params.id ? [params.id] : []
        const giftListG = await this.checkGiftListByGoodId(idsArr, 'submit')
        if (giftListG.length > 0) {
          giftListG.forEach(e => { tempGiftIdArr.push(e.id) })
        }
      }
      /**    checkGift By Goods end     **/

      /**    action GiftPutOff     **/
      const actionArr = Array.from(new Set(tempGiftIdArr))
      // return console.log('actionArr', actionArr)
      if (actionArr.length > 0) { await this.onGiftPutOff(actionArr) }
      /**    action GiftPutOff end     **/

      // return console.log('提交数据', params.skuList)
      // return
      params.status = '1'
      console.log(params)
      if (this.currentPageStatus === 'add') {
        // 添加
        if (this.time == 0) {
          this.time = 3; //设定间隔时间（秒）
          //启动计时器，倒计时time秒后自动关闭计时器。
          var index = setInterval(function () {
            this.time--;
            if (this.time == 0) {
              clearInterval(index);
            }
          }, 1000);
          this.$api.goodsAdd(params).then((res) => {
            if (res.code === 0) {
              // this.$message({ type: 'success', message: '添加商品成功!' })
              this.$notify({
                title: '成功',
                message: '添加商品成功!',
                type: 'success',
                duration: 3000
              })
              this.toOtherPages('goodsList')
            } else {
              this.time = 0
            }
          }).catch((err) => {
            console.log(err)
          })

        } else {
          this.$message.warning('已提交，无需再次提交')
          console.log('已提交，无需再次提交');
        }



      } else {
        // 编辑
        delete params.attrGroupList
        delete params.categoryInfo
        delete params.goodsNo
        params.id = this.$route.query.id
        params.platformGoodsNo = null
        this.$api.goodsAdd(params).then((res) => {
          if (res.code === 0) {
            // this.$message({ type: 'success', message: '添加商品成功!' })
            this.$notify({
              title: '成功',
              message: '修改商品成功!',
              type: 'success',
              duration: 3000
            })
            this.toOtherPages('goodsList')
          }
        }).catch((err) => {
          console.log(err)
          this.initialization() // 初始化 信息
        })
      }
    },
    batchSetPrice(dataList) {
      if (!dataList || dataList.length===0) {
        return
      }
      for(let i = 0;i<dataList.length;i++){
        let sku = this.skuFormConfig.sku[i]
        if(!sku){
          return
        }
        let item = dataList[i]
        this.$refs.skuForm.init()
        if(item.length >= 1){
          this.skuFormConfig.sku[i].marketPrice = Number(item[0])
        }
        if(item.length >= 2){
          this.skuFormConfig.sku[i].retailPrice = Number(item[1])
        }
        if(item.length >= 3){
          this.skuFormConfig.sku[i].costPrice = Number(item[2])
        }
        if(item.length >= 4){
          this.skuFormConfig.sku[i].purchasePrice = Number(item[3])
        }
        if(item.length >= 5){
          this.skuFormConfig.sku[i].settlementPrice = Number(item[4])
        }
        if(item.length >= 6){
          this.skuFormConfig.sku[i].convertPrice = Number(item[5])
        }
        if(item.length >= 7){
          this.skuFormConfig.sku[i].bulkPurchasePrice = Number(item[6])
        }
        if(item.length >= 8){
          this.skuFormConfig.sku[i].agentPrice = Number(item[7])
        }
        this.$forceUpdate()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./style/modifyState.scss";

// ::v-deep .el-table th > .cell {
//   text-align: center;
//   font-size: 14px !important;
// }
.remark {
  width: 40%;
  border: 1px solid #e3e3e3;
  border-radius: 6px;

  .remark-c {
    margin-left: 8px;
  }
}

.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

// .content{color: #333333!important;}
//删除全页面按钮边框
.el-button {
  border: none;
}

.image-text-form {
  .el-form {
    .el-form-item {
      &:first-child {
        .el-form-item__label {
          &:before {
            color: #ff0000;
            content: "*";
          }
        }
      }
    }
  }
}

.goods-category-edit {
  .edit-btn {
    background-color: #e3edff;
    color: #4168e7;
    font-size: 14px;
    text-align: center;
    width: 44px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    padding: 3px 8px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.status-box {
  font-size: 16px;
  height: 40px;
  line-height: 40px;

  .list,
  .right {
    float: left;
  }

  .list {
    width: 100px;
    text-align: center;
  }

  .right {
    padding-top: 15px;
    width: calc(100% - 100px);

    .el-radio__label {
      font-size: 16px;
    }
  }
}

.bottom-but {
  margin-top: -20px;
  text-align: center;

  .el-button {
    width: 220px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button+.el-button {
    margin-left: 32px;
  }
}

.el-select {
  border-left: 1px solid #d8dce5;
  border-right: 1px solid #d8dce5;
  border-radius: 5px;

  input[type="text"],
  input[type="number"] {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
}

.attr {
  margin-top: 0;
}

.content {
  padding-bottom: 10px !important;
}

//v1.4.0新增
.labelbox {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .labelitem {
    background-color: #f0f3fd;
    padding: 2px 20px;
    font-size: 14px;
    color: #4168e7;
    position: relative;
    margin-right: 20px;
    line-height: 28px;

    .labelicon {
      color: #4168e7;
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      right: -6px;
      top: -6px;
    }
  }
}

.loglabelbox {
  padding: 20px 0;
  box-sizing: border-box;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;

  .loglabeltopbox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    border-bottom: 1px dashed #cccccc;

    .labelitem {
      background-color: #f0f3fd;
      padding: 2px 20px;
      font-size: 14px;
      color: #4168e7;
      position: relative;
      margin-right: 20px;
      margin-bottom: 14px;
      cursor: pointer;
    }

    .labelitemc {
      .labelicon {
        color: #4168e7;
        cursor: pointer;
        position: absolute;
        font-size: 16px;
        right: -6px;
        top: -6px;
      }
    }

    .notselected {
      background-color: #4168e7;
      color: #ffffff;
    }

    .selected {
      background-color: #f3f3f3;
      color: #333333;
    }
  }

  .circlebox {
    font-size: 16px;
    color: #4168e7;
    display: flex;
    margin-top: 14px;
    align-items: center;
    margin-bottom: 14px;

    .circle {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 50%;
      background-color: #4168e7;
      color: white;
      font-size: 12px;
      margin-left: 10px;
      box-sizing: border-box;
    }
  }
}

.circle1 {
  width: 10px;
  height: 10px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  background-color: #4168e7;
  color: white;
  font-size: 12px;
  margin-left: 10px;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 4px;
}

.primary-button {
  width: 120px;
  height: 36px;
  background: #4168e7;
  border-radius: 4px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-mini {
  width: 68px;
  height: 32px;
  background: #e3edff;
  border-radius: 4px;
  line-height: 32rpx;
  text-align: center;
  font-size: 16px;
  color: #4168e7;
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
}

.primary-plain {
  width: 120px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #4168e7;
  border-radius: 4px;
  line-height: 36px;
  color: #4168e7;
  text-align: center;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-gray {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
  line-height: 36px;
  text-align: center;
  color: #999999;
}
</style>
